<template>
  <div id="frm">
    <win-layer-pop class="inquiry_surcharge_pop">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
        :parent-info="surChargeParams"
      />
    </win-layer-pop>
    <div class="content_box beforetab">
      <table style="width: 100%;">
        <tbody>
          <tr>
            <td style="width: 200px; padding-right: 10px;">
              <th style="text-align: center;">{{ $t('msg.FARE010T010_NEW.001') }}</th><!-- 출발 -->
              <e-auto-complete-place
                id="polPol"
                @change="changePol"
                :ctr-cd="params.porCtrCd"
                :plc-cd="params.porPlcCd"
                :is-char="true"
                :is-char-alert="true"
                plaholder="Enter Origin"
              />
            </td>
            <td style="width: 200px; padding-right: 10px;">
              <th style="text-align: center;">{{ $t('msg.FARE010T010_NEW.002') }}</th><!-- 도착 -->
              <e-auto-complete-place
                id="podPod"
                @change="changePod"
                :ctr-cd="params.dlyCtrCd"
                :plc-cd="params.dlyPlcCd"
                :is-char="true"
                :is-char-alert="true"
                plaholder="Enter Destination"
              />
            </td>
            <td style="width: 150px; padding-right: 10px;">
              <th style="text-align: center;">{{ $t('msg.FARE010T010_NEW.003') }}</th><!-- 예상 출항일 -->
              <div class="input_calendar">
                <e-date-picker
                  id="etd"
                  style="width: 147px;"
                  v-model="params.etd"
                />
              </div>
            </td>
            <td style="width: 247px; padding-right: 10px;">
              <div class="flex_box" style="justify-content: flex-end;">
                <div style="margin-left:25px;">
                  <th style="text-align: center;">{{ $t('msg.FARE010T010_NEW.027') }}</th><!-- Container -->
                  <span>
                    <input type="checkbox" id="cntr20Yn" v-model="cntr20Yn" true-value="1" false-value="0" />
                    <label for="cntr20Yn"><span></span>&nbsp;20'</label>
                  </span>
                  <span class="ml20">
                    <input type="checkbox" id="cntr40Yn" v-model="cntr40Yn" true-value="1" false-value="0" />
                    <label for="cntr40Yn"><span></span>&nbsp;40' / HC</label>
                  </span>
                  <span class="ml20">
                    <input type="checkbox" id="cntrHzYn" v-model="cntrHzYn" true-value="1" false-value="0" />
                    <label for="cntrHzYn"><span></span>&nbsp;HZ</label>
                  </span>
                </div>
              </div>
            </td>
            <td style="padding-left: 49px;">
              <div class="flex_box mt5">
                <a style="height: 32px; width: 50px;" class="button blue lg ml5" href="#" @click.prevent="fnSearchSurCharge()">{{ $t('msg.FARE010T010_NEW.004') }}</a><!-- 검색 -->
              </div>
            </td>
            <td style="padding-top: 5px;" colspan="2">
              <div class="flex_box" style="flex-direction: row-reverse;">
                <span style="margin-left: 5px;" class="position_relative">
                  <a id="histo" style="background-color: #E5EEFF; overflow: hidden; white-space: nowrap; line-height: 0; color: black; border: 1px solid #C7DAFF; height: 32px; width: 90px; padding-left: 5px; align-content: center; font-size: small; margin-left: 10px;" @click="showHisto = !showHisto" class="button grey lg"><a id="histo" class="tbl_icon new_histo"></a>{{ $t('msg.FARE010T010_NEW.007') }}</a>
                  <div v-show="showHisto" class="tooltip_wrap short position_absolute" style="background-color: #F0F5FF; width:285px; left:9px; top:31px; padding-bottom: 11px;">
                    <div class="cont" style="padding: 0px; margin-right: 10px;">
                      <button style="right:16px;" type="button" class="close" @click="showHisto = false">close</button>
                      <ul class="bul_list_sm t2">
                        <div class="content_box mt10 ml10" style="padding: 0;">
                          <div class="flex_box" style="padding: 4px; background-color: #E5EEFF; height: 31px;">
                            <a class="tbl_icon new_histo"></a>
                            <th style="text-align: center; padding-left: 9px; font-size: medium;">{{ $t('msg.FARE010T010_NEW.007') }}</th><!-- 최근조회구간 -->
                          </div>
                          <div style="padding: 4px;">
                            <ul v-for="(item, index) in recentScheduleList" :key="index">
                              <ul>
                                <input
                                  type="radio"
                                  :id="item.logRno"
                                  :value="item.logRno"
                                  :checked="item.logRno === schId"
                                  name="mysch"
                                  @click="selectRecentSchedule(item)"
                                />
                                <label id="searchRadio" :for="item.logRno"><span class="offscreen">{{ item.logRno }}</span>
                                  {{ item.polPortNm }}
                                  <span v-if="item.tsYn === 'Y'" class="arr">&nbsp;&gt;&nbsp;</span>
                                  {{ item.tsYn === 'Y' ? '(T/S) '+item.pod1PortNm : '' }}
                                  <span class="arr">&nbsp;&gt;&nbsp;</span>
                                  {{ item.podPortNm }}
                                </label>
                              </ul>
                            </ul>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </span>
                <span class="position_relative">
                  <a id="favor" style="background-color: #E5EEFF; overflow: hidden; white-space: nowrap; line-height: 0; color: black; border: 1px solid #C7DAFF; height: 32px; width: 90px; padding-left: 5px; align-content: center; font-size: small; margin-left: 10px;" @click="showFavor = !showFavor" class="button grey lg"><a id="favor" class="tbl_icon new_favor"></a>{{ $t('msg.FARE010T010_NEW.006') }}</a>
                  <div v-show="showFavor" class="tooltip_wrap short position_absolute" style="background-color: #F0F5FF; width:285px; left:9px; top:31px; padding-bottom: 11px;">
                    <div class="cont" style="padding: 0px; margin-right: 10px;">
                      <button style="right:16px;" type="button" class="close" @click="showFavor = false">close</button>
                      <ul class="bul_list_sm t2">
                        <div class="content_box mt10 ml10" style="padding: 0;">
                          <div class="flex_box" style="padding: 4px; background-color: #E5EEFF; height: 31px;">
                            <a class="tbl_icon new_favor"></a>
                            <th style="text-align: center; padding-left: 9px; font-size: medium;">{{ $t('msg.FARE010T010_NEW.006') }}</th><!-- 나의 즐겨찾기 -->
                          </div>
                          <div style="padding: 4px;">
                            <ul style="margin-top: 5px;" v-for="(list,index) in myScheduleList" :key="index">
                              <input
                                type="radio"
                                :id="list.schId"
                                :value="list.schId"
                                :checked="list.schId === schId"
                                name="mysch"
                                @click="selectMySchedule(list)"
                              />
                              <label id="searchRadio" :for="list.schId"><span></span>{{ list.polNm2 }} > {{ list.podNm2 }}</label>
                            </ul>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="border-color: #2441BA; position: fixed; top: 43px; z-index: 101; width: 1250px;" class="content_box mt10" v-show="isFixed && searchYn">
      <div class="flex_box">
        <div style="width: 90%; margin-right: 20px;">
          <p class="port" style="color: #345EBB; height: 45px; font-size: x-large;">
            <span style="padding-top: 3px;">{{ params.polNm }}</span>
            <span style="background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 18px;">{{ params.podNm }}</span>
            <span style="background: none;" class="icon" v-if="$ekmtcCommon.isNotEmpty(userCtrCd)">
              <div v-if="myScheduleOrNot === 'N'">
                <button style="margin-top: -5px;" class="tbl_icon myschedule" @click="fnAddMySchedule()"><!-- 나의스케줄등록 --></button>
              </div>
              <div v-else>
                <button style="margin-top: -5px;" class="tbl_icon myschedule on" @click="deleteMyScheduleStar(schId)"><!-- 나의스케줄등록 --></button>
              </div>
            </span>
            <a style="display: list-item; margin-left: 25px; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 1 && this.startDtGP !== ''">Validity Period : {{ this.startDtGP }} ~ {{ this.endDtGP }}</a>
            <a style="display: list-item; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 1 && this.frtAppNoGP !== ''">SC No. : {{ this.frtAppNoGP }}</a>
            <a style="display: list-item; margin-left: 25px; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 2 && this.startDtRF !== ''">Validity Period : {{ this.startDtRF }} ~ {{ this.endDtRF }}</a>
            <a style="display: list-item; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 2 && this.frtAppNoRF !== ''">SC No. : {{ this.frtAppNoRF }}</a>
          </p>
        </div>
        <div>
          <a id="freeTime" style="border-color:#C7DAFF; background-color: #E5EEFF; color: #075bb9; font-size: smaller;" @click="showFree = !showFree" class="button blue sm"><span style="background-position: -2px -1px;" class="tbl_icon new_freetime"></span>Free Time</a>
        </div>
      </div>
    </div>
    <div ref="headerXPos" style="border-color: #2441BA;" class="content_box mt10" v-show="searchYn">
      <div class="flex_box">
        <div style="width: 90%; margin-right: 20px;">
          <p class="port" style="color: #345EBB; height: 45px; font-size: x-large;">
            <span style="padding-top: 3px;">{{ searchPolNm }}</span>
            <span style="background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 18px;">{{ searchPodNm }}</span>
            <span style="background: none;" class="icon" v-if="$ekmtcCommon.isNotEmpty(userCtrCd)">
              <div v-if="myScheduleOrNot === 'N'">
                <button style="margin-top: -5px;" class="tbl_icon myschedule" @click="fnAddMySchedule()"><!-- 나의스케줄등록 --></button>
              </div>
              <div v-else>
                <button style="margin-top: -5px;" class="tbl_icon myschedule on" @click="deleteMyScheduleStar(schId)"><!-- 나의스케줄등록 --></button>
              </div>
            </span>
            <a style="display: list-item; margin-left: 25px; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 1 && this.startDtGP !== ''">Validity Period : {{ this.startDtGP }} ~ {{ this.endDtGP }}</a>
            <a style="display: list-item; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 1 && this.frtAppNoGP !== ''">SC No. : {{ this.frtAppNoGP }}</a>
            <a style="display: list-item; margin-left: 25px; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 2 && this.startDtRF !== ''">Validity Period : {{ this.startDtRF }} ~ {{ this.endDtRF }}</a>
            <a style="display: list-item; margin-top: 13px; float: right; font-size: small; color: black;" v-if="tapStatus === 2 && this.frtAppNoRF !== ''">SC No. : {{ this.frtAppNoRF }}</a>
          </p>
        </div>
        <div>
          <a id="freeTime" style="border-color:#C7DAFF; background-color: #E5EEFF; color: #075bb9; font-size: smaller;" @click="showFree = !showFree" class="button blue sm"><span style="background-position: -2px -1px;" class="tbl_icon new_freetime"></span>Free Time</a>
        </div>
      </div>
    </div>
    <table style="width: 1260px;">
      <colgroup>
        <col width="75%">
        <col width="25%">
      </colgroup>
      <tbody>
        <tr>
          <div style="align-content: center; text-align: center; background-color: rgba(246, 249, 255); height: 450px; width: 132.4%;" class="content_box mt10" v-show="!searchYn">
            <a>{{ $t('msg.FARE010T010_NEW.008') }}</a>
          </div>
          <td style="align-content: flex-start;">
            <div class="content_box mt10" v-show="searchYn">
              <div class="ml25 flex_box">
                <li style="font-size: 16px; color: #075bb9; font-weight: 500;">FAK(Freight All Kinds)</li>
                <!-- <div style="display: flex; justify-content: flex-end; width: 79.3%;">
                  <a v-show="tapStatus === 1" style="border-color:#C7DAFF; background-color: #E5EEFF; color: #075bb9; font-size: 14px;" class="button blue lg print" href="#" v-print="'#print_screen_gp'"><span class="tbl_icon new_print"></span>{{ $t('msg.FARE010T010_NEW.028') }}</a>
                  <a v-show="tapStatus === 2" style="border-color:#C7DAFF; background-color: #E5EEFF; color: #075bb9; font-size: 14px;" class="button blue lg print" href="#" v-print="'#print_screen_rf'"><span class="tbl_icon new_print"></span>{{ $t('msg.FARE010T010_NEW.028') }}</a>
                </div> -->
              </div>
              <div style="margin-top: 15px; cursor: pointer; float: right;">
                <a style="font-size: small; color: #075bb9;" @click.prevent="showDetail()">{{ $t('msg.FARE010T010_NEW.064') }} <a v-show="detailYn !== 'Y'" class="tbl_icon new_plus"></a><a v-show="detailYn === 'Y'" class="tbl_icon new_minus"></a></a>
              </div>
              <div class="tab">
                <ul>
                  <li v-show="surChargeListDry.length > 0" class="on" id="tab1" @click="selectTab(1)"><a href="javascript:void(0)">{{ $t('msg.FARE010T010_NEW.009') }}</a></li>  <!-- 프린트 / 다운로드 -->
                  <li v-show="surChargeListRee.length > 0" id="tab2" @click="selectTab(2)"><a href="javascript:void(0)">{{ $t('msg.FARE010T010_NEW.010') }}</a></li> <!-- 프린트 / 다운로드 -->
                </ul>
              </div>
              <div style="background-color: #F0F5FF;" class="content_box" v-show="tapStatus === 1">
                <div id="print_screen_gp" @submit.prevent>
                  <table class="tbl_col mt10">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Freight Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row,idx) in surChargeListDry" :key="idx">
                        <td :rowspan="row.frtCd == 'O/F' ? 2 : 1" class="text_left" v-show="row.cgoTypCd !== '01' && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'"><label :for="`idxGP${idx}`"><span>&nbsp;</span>{{ row.frtCdNm }}</label></td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                        <td v-show="v20Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.cntrTypCd === 'GP'">
                            <!-- cargo hz(01)가 아닌 경우 또는  컨테이너 타입 GP만 프로모션 계산 대상 -->
                            <div v-if="row.rate20 !== '' && row.rate20 !== '0' && frtAppNo === '' && of20Rate !== '' && of20Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('20', parseInt(row.rate20) + parseInt(of20Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else-if="row.rate20 !== '' && row.rate20 !== '0' && of20Rate !== '' && of20Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('20', parseInt(row.rate20) + parseInt(of20Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else>
                              <!-- GP이외 일반 가격을 보여줌 -->
                              <div v-if="row.rate20 !== '' && row.rate20 !== '0' && frtAppNo === '' && of20Rate !== '' && of20Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                              </div>
                              <div v-else-if="row.rate20 !== '' && row.rate20 !== '0' && of20Rate !== '' && of20Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                              </div>
                              <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}</div>
                            </div>
                          </div>
                          <div v-else>
                            <!-- GP이외 일반 가격을 보여줌 -->
                            <div v-if="row.rate20 !== '' && row.rate20 !== '0' && frtAppNo === '' && of20Rate !== '' && of20Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                            </div>
                            <div v-else-if="row.rate20 !== '' && row.rate20 !== '0' && of20Rate !== '' && of20Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                            </div>
                            <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}</div>
                          </div>
                        </td>
                        <td v-show="v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.cntrTypCd === 'GP'">
                            <!-- cargo hz(01)가 아닌 경우 프로모션 계산 대상 -->
                            <div v-if="row.rate40 !== '' && row.rate40 !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('40', parseInt(row.rate40) + parseInt(of40Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else-if="row.rate40 !== '' && row.rate40 !== '0' && of40Rate !== '' && of40Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('40', parseInt(row.rate40) + parseInt(of40Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else>
                              <!-- GP이외 일반 가격을 보여줌 -->
                              <div v-if="row.rate40 !== '' && row.rate40 !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                              </div>
                              <div v-else-if="row.rate40 !== '' && row.rate40 !== '0' && of40Rate !== '' && of40Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                              </div>
                              <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}</div>
                            </div>
                          </div>
                          <div v-else>
                            <!-- GP이외 일반 가격을 보여줌 -->
                            <div v-if="row.rate40 !== '' && row.rate40 !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                            </div>
                            <div v-else-if="row.rate40 !== '' && row.rate40 !== '0' && of40Rate !== '' && of40Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                            </div>
                            <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}</div>
                          </div>
                        </td>
                        <td v-show="v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.cntrTypCd === 'GP'">
                            <!-- cargo hz(01)가 아닌 경우 프로모션 계산 대상 -->
                            <div v-if="row.rateHc !== '' && row.rateHc !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('40', parseInt(row.rateHc) + parseInt(of40Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else-if="row.rateHc !== '' && row.rateHc !== '0' && of40Rate !== '' && of40Rate !== undefined">
                              <del>{{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}</del>&nbsp;&nbsp;
                              <img src="../../assets/images/common/icon_port_arrow.png" style="margin-top:6px">&nbsp;&nbsp;
                              {{ calcPromotionDC('40', parseInt(row.rateHc) + parseInt(of40Rate), row.frtCd, row.cntrTypCd, row.cgoTypNm) }}
                            </div>
                            <div v-else>
                              <!-- GP이외 일반 가격을 보여줌 -->
                              <div v-if="row.rateHc !== '' && row.rateHc !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                              </div>
                              <div v-else-if="row.rateHc !== '' && row.rateHc !== '0' && of40Rate !== '' && of40Rate !== undefined">
                                {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                              </div>
                              <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}</div>
                            </div>
                          </div>
                          <div v-else>
                            <!-- GP이외 일반 가격을 보여줌 -->
                            <div v-if="row.rateHc !== '' && row.rateHc !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                            </div>
                            <div v-else-if="row.rateHc !== '' && row.rateHc !== '0' && of40Rate !== '' && of40Rate !== undefined">
                              {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                            </div>
                            <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}</div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <p class="txt_desc2">{{ $t('msg.FARE010T010_NEW.029') }}</p>
                <p class="txt_desc2">{{ $t('msg.FARE010T010_NEW.030') }}</p> -->
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Export Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <!-- 일반운임 선택시 -->
                    <tr v-for="(row,idx) in surChargeListDry" :key="'a' + idx">
                      <td class="text_left" v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.frtCdNm }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                      <td v-show="v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}
                      </td>
                    </tr>
                  </table>
                  <!-- Import Charge -->
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Import Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <!-- 일반운임 선택시 -->
                    <tr v-for="(row,idx) in surChargeListDry" :key="'a' + idx">
                      <td class="text_left" v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.frtCdNm }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                      <td v-show="v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}
                      </td>
                    </tr>
                  </table>
                  <!-- Notes -->
                  <div v-show="surChargeNoteGPList.length !== 0 && detailYn === 'Y'">
                    <p class="txt_desc asterisk">Notes<br /></p>
                    <div v-for="(row,idx) in surChargeNoteGPList" :key="idx">
                      <div v-show="row.frtCd === 'DCF' || row.frtCd === 'SRD' || row.frtCd === 'AFS' || row.frtCd === 'AMS'">
                        <p class="txt_desc2">{{ idx+1 }}. Subject to {{ row.frtCdNm }} : {{ row.curCd }} {{ $ekmtcCommon.changeNumberFormat(row.blRate, { isComma: true }) }} per Bill of Lading.<br /></p>
                      </div>
                      <div v-show="idx === (surChargeNoteGPList.length-1)">
                        <p class="txt_desc2">{{ idx+2 }}. Subject to SPECIAL DG HANDLING SURCHARGE : USD 600/20', USD 700/40' per container (※For only DG CLASS 2 by BUSAN T/S).<br /></p>
                        <p v-show="params.porCtrCd === 'JP'" class="txt_desc2">
                          {{ idx+3 }}. 3ヶ月更新のLSS(Low Sulphur Surcharge)は、お見積もりのタイミングによって表示されない場合がございます。
                          料率が決まり次第表示されますが、ご不明な点がございましたら弊社営業部までお問い合わせください。<br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Notes -->
                  <!-- Destination Freetime -->
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;" rowspan="2">KIND</th>
                        <th style="color: black; background-color: #E5EEFF;" colspan="2">Loading</th>
                        <th style="color: black; background-color: #E5EEFF;" colspan="2">Discharging</th>
                      </tr>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF; border-left:1px solid #e1e3eb;">GP</th>
                        <th style="color: black; background-color: #E5EEFF;">HC</th>
                        <th style="color: black; background-color: #E5EEFF;">GP</th>
                        <th style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row,idx) in rateFreeDdsGPList" :key="idx">
                        <td class="text_left">{{ row.demDetCatNm }}</td>
                        <td>{{ row.ldGpFreeDds }}</td>
                        <td>{{ row.ldHcFreeDds }}</td>
                        <td>{{ row.disGpFreeDds }}</td>
                        <td>{{ row.disHcFreeDds }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div style="background-color: #F0F5FF;" class="content_box" v-show="tapStatus === 2">
                <div id="print_screen_rf" @submit.prevent>
                  <table class="tbl_col mt10">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Freight Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- 메뉴 유입시 (일반) -->
                      <tr v-for="(row,idx) in surChargeListRee" :key="idx">
                        <td :rowspan="row.frtCd == 'O/F' ? 2 : 1" class="text_left" v-show="row.cgoTypCd !== '01' && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'"><label :for="`idxRF${idx}`"><span>&nbsp;</span>{{ row.frtCdNm }}</label></td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                        <td v-show="row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                        <td v-show="v20Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.rate20 !== '' && row.rate20 !== '0' && frtAppNo === '' && of20Rate !== '' && of20Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                          </div>
                          <div v-else-if="row.rate20 !== '' && row.rate20 !== '0' && of20Rate !== '' && of20Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate20) + parseInt(of20Rate), { isComma: true }) }}
                          </div>
                          <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}</div>
                        </td>
                        <td v-show="v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.rate40 !== '' && row.rate40 !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                          </div>
                          <div v-else-if="row.rate40 !== '' && row.rate40 !== '0' && of40Rate !== '' && of40Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rate40) + parseInt(of40Rate), { isComma: true }) }}
                          </div>
                          <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}</div>
                        </td>
                        <td v-show="v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                          <div v-if="row.rateHc !== '' && row.rateHc !== '0' && frtAppNo === '' && of40Rate !== '' && of40Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                          </div>
                          <div v-else-if="row.rateHc !== '' && row.rateHc !== '0' && of40Rate !== '' && of40Rate !== undefined">
                            {{ $ekmtcCommon.changeNumberFormat(parseInt(row.rateHc) + parseInt(of40Rate), { isComma: true }) }}
                          </div>
                          <div v-else>{{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Export Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <!-- 일반운임 선택시 -->
                    <tr v-for="(row,idx) in surChargeListRee" :key="'a' + idx">
                      <td class="text_left" v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.frtCdNm }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                      <td v-show="v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}
                      </td>
                    </tr>
                  </table>
                  <!-- Import Charge -->
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="30%">
                      <col width="12%">
                      <col width="10%">
                      <col width="12%">
                      <col v-show="v20Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                      <col v-show="v40Yn" width="12%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;">Import Charges</th>
                        <th style="color: black; background-color: #E5EEFF;">Currency</th>
                        <th style="color: black; background-color: #E5EEFF;">Type</th>
                        <th style="color: black; background-color: #E5EEFF;">Cargo</th>
                        <th v-show="v20Yn" style="color: black; background-color: #E5EEFF;">20'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">40'</th>
                        <th v-show="v40Yn" style="color: black; background-color: #E5EEFF;">HC</th>
                      </tr>
                    </thead>
                    <!-- 일반운임 선택시 -->
                    <tr v-for="(row,idx) in surChargeListRee" :key="'a' + idx">
                      <td class="text_left" v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.frtCdNm }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.curCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cntrTypCd === 'RF'?'Reefer':row.cntrTypCd }}</td>
                      <td v-show="row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">{{ row.cgoTypNm }}</td>
                      <td v-show="v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate20, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rate40, { isComma: true }) }}
                      </td>
                      <td v-show="v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'">
                        {{ $ekmtcCommon.changeNumberFormat(row.rateHc, { isComma: true }) }}
                      </td>
                    </tr>
                  </table>
                  <!-- Notes -->
                  <div v-show="surChargeNoteRFList.length !== 0 && detailYn === 'Y'">
                    <p class="txt_desc asterisk">Notes<br /></p>
                    <div v-for="(row,idx) in surChargeNoteRFList" :key="idx">
                      <div v-show="row.frtCd === 'DCF' || row.frtCd === 'SRD' || row.frtCd === 'AFS' || row.frtCd === 'AMS'">
                        <p class="txt_desc2">{{ idx+1 }}. Subject to {{ row.frtCdNm }} : {{ row.curCd }} {{ $ekmtcCommon.changeNumberFormat(row.blRate, { isComma: true }) }} per Bill of Lading.<br /></p>
                      </div>
                      <div v-show="idx === (surChargeNoteRFList.length-1)">
                        <p class="txt_desc2">{{ idx+2 }}. Subject to SPECIAL DG HANDLING SURCHARGE : USD 600/20', USD 700/40' per container (※For only DG CLASS 2 by BUSAN T/S).<br /></p>
                        <p v-show="params.porCtrCd === 'JP'" class="txt_desc2">
                          {{ idx+3 }}. 3ヶ月更新のLSS(Low Sulphur Surcharge)は、お見積もりのタイミングによって表示されない場合がございます。
                          料率が決まり次第表示されますが、ご不明な点がございましたら弊社営業部までお問い合わせください。<br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Notes -->
                  <!-- Destination Freetime -->
                  <table class="tbl_col mt10" v-show="detailYn === 'Y'">
                    <colgroup>
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF;" rowspan="2">KIND</th>
                        <th style="color: black; background-color: #E5EEFF;" colspan="2">Loading</th>
                        <th style="color: black; background-color: #E5EEFF;" colspan="2">Discharging</th>
                      </tr>
                      <tr>
                        <th style="color: black; background-color: #E5EEFF; border-left:1px solid #e1e3eb;">RF</th>
                        <th style="color: black; background-color: #E5EEFF;">RH</th>
                        <th style="color: black; background-color: #E5EEFF;">RF</th>
                        <th style="color: black; background-color: #E5EEFF;">RH</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row,idx) in rateFreeDdsRFList" :key="idx">
                        <td class="text_left">{{ row.demDetCatNm }}</td>
                        <td>{{ row.ldGpFreeDds }}</td>
                        <td>{{ row.ldHcFreeDds }}</td>
                        <td>{{ row.disGpFreeDds }}</td>
                        <td>{{ row.disHcFreeDds }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!--
              <div style="align-content: center; text-align: center; background-color: rgba(246, 249, 255); height: 245px; width: 100%;" class="content_box mt10" v-show="tapStatus === 2">
                <a>{{ $t('msg.FARE010T010_NEW.058') }}</a>
              </div> -->
              <div v-show="kmtcSpotUserYn === 'Y' && kmtcOnNowDisabledYn !== 'Y' && tapStatus === 1" class="ml25 mt20 flex_box">
                <li style="font-size: 16px; color: #075bb9; font-weight: 500;">KMTC ON NOW</li>
              </div>
              <div
                v-if="kmtcSpotUserYn === 'Y' && kmtcOnNowDisabledYn === 'Y'"
                class="content_box mt10"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                  background-color: rgba(246, 249, 255);
                  height: 245px;
                  width: 100%;
                "
              >
                <div>
                  <p
                    v-if="kmtcOnNowNoticeMsg !== ''"
                    style="
                      font-size: 18px;
                      font-weight: 600;
                      color: #000;
                      margin-bottom: 8px;
                    "
                  >
                    {{ kmtcOnNowNoticeMsg }}
                  </p>

                  <p
                    v-if="kmtcOnNowNoticeSubMsg !== ''"
                  >
                    {{ kmtcOnNowNoticeSubMsg }}
                  </p>
                </div>
              </div>
              <div v-show="kmtcSpotUserYn === 'Y' && tapStatus === 1 && kmtcOnNowDisabledYn !== 'Y'" style="background-color: #F0F5FF;" class="content_box mt10">
                <div v-show="dcYn != 'Y'">
                  <a style="font-size: medium; color: black;">{{ $t('msg.FARE010T010_NEW.031') }}<br></a>
                  <a style="font-size: small; color: black;">{{ $t('msg.FARE010T010_NEW.032') }}</a>
                </div>
                <div v-show="dcYn == 'Y'">
                  <a style="font-size: medium; color: black;">{{ $t('msg.FARE010T010_NEW.059') }}<br></a>
                  <a style="font-size: small; color: black;">{{ $t('msg.FARE010T010_NEW.060') }}</a>
                </div>
                <table style="width: 100%; margin-top: 5px;">
                  <colgroup>
                    <col style="width: 50%" />
                    <col style="width: 50%" />
                  </colgroup>
                  <tbody>
                    <tr style="width: 100%;">
                      <td colspan="2">
                        <table style="border:solid 1px #C7DAFF; width: 100%;">
                          <tr>
                            <th style="text-align: center; height: 50px; font-weight: 500; background-color: #E5EEFF; width:150px; color: black;">{{ $t('msg.FARE010T010_NEW.033') }}</th>
                            <td style="background-color: #E5EEFF; border-right: 0px;">
                              <input
                                v-show="dcYn != 'Y'"
                                id="kmtcOnShprNm"
                                style="width: 98%; margin-left:5px; height: 33px;"
                                v-model="params.kmtcOnShprNm"
                                type="text"
                                class="txt_jp"
                                maxlength="50"
                                placeholder="Enter B/L Shipper Name"
                              />
                              <a v-show="dcYn == 'Y'" style="font-size: large; color: #075bb9;">{{ saveShprNm }}</a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="border-top: solid 5px #F0F5FF;">
                        <table style="border:solid 1px #C7DAFF; width: 100%;">
                          <tr>
                            <th style="text-align: center; height: 50px; font-weight: 500; background-color: #E5EEFF; color: black;">20' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                          </tr>
                          <tr style="height: 100px;">
                            <td style="background-color: white; border-right: 0px; height: 33px;">
                              <table style="width: 100%; margin-top: 5px;">
                                <colgroup>
                                  <col style="width: 45%" />
                                  <col style="width: 1%" />
                                  <col style="width: 45%" />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <td style="text-align: center;">
                                      <div style="margin-bottom: 10px;">
                                        <a style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.034') }}</a>
                                      </div>
                                      <a style="font-weight: 400; font-size: large; color: #075bb9;">USD </a>
                                      <a :style="{textDecorationLine: dcYn == 'Y' ? 'line-through' : 'none'}" style="font-weight: 400; font-size: large; color: #075bb9;">{{ calcuAmt.from20 }}</a>
                                      <a style="font-weight: 400; font-size: medium; color: #075bb9;"> / TEU</a>
                                    </td>
                                    <td style="font-weight: 700;">
                                      →
                                    </td>
                                    <td style="text-align: center;">
                                      <div style="margin-bottom: 10px;">
                                        <a v-show="dcYn != 'Y'" style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.035') }}</a>
                                        <a v-show="dcYn == 'Y'" style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.036') }}</a>
                                      </div>
                                      <e-input-number
                                        v-show="dcYn != 'Y'"
                                        id="kmtcOn20"
                                        @input="setCalcuData()"
                                        style="width: 145px; margin-left:5px; height: 33px;"
                                        v-model="params.kmtcOn20"
                                        maxlength="5"
                                        placeholder="Enter your Target Rate"
                                      />
                                      <a v-show="dcYn == 'Y'" style="font-weight: 400; font-size: large; color: #075bb9;">USD {{ calcuAmt.kmtcFrom20 }}</a>
                                      <a style="font-weight: 400; font-size: medium; color: #075bb9;"> / TEU</a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="border-left: solid 5px #F0F5FF; border-top: solid 5px #F0F5FF;">
                        <table style="border:solid 1px #C7DAFF; width: 100%;">
                          <tr>
                            <th style="text-align: center; height: 50px; font-weight: 500; background-color: #E5EEFF; color: black;">40' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                          </tr>
                          <tr style="height: 100px;">
                            <td style="background-color: white; border-right: 0px; height: 33px;">
                              <table style="width: 100%; margin-top: 5px;">
                                <colgroup>
                                  <col style="width: 45%" />
                                  <col style="width: 1%" />
                                  <col style="width: 45%" />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <td style="text-align: center;">
                                      <div style="margin-bottom: 10px;">
                                        <a style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.034') }}</a>
                                      </div>
                                      <a style="font-weight: 400; font-size: large; color: #075bb9;">USD </a>
                                      <a :style="{textDecorationLine: dcYn == 'Y' ? 'line-through' : 'none'}" style="font-weight: 400; font-size: large; color: #075bb9;">{{ calcuAmt.from40 }}</a>
                                      <a style="font-weight: 400; font-size: medium; color: #075bb9;"> / FEU</a>
                                    </td>
                                    <td style="font-weight: 700;">
                                      →
                                    </td>
                                    <td style="text-align: center;">
                                      <div style="margin-bottom: 10px;">
                                        <a v-show="dcYn != 'Y'" style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.035') }}</a>
                                        <a v-show="dcYn == 'Y'" style="font-weight: 400; font-size: medium; color: #075bb9;">{{ $t('msg.FARE010T010_NEW.036') }}</a>
                                      </div>
                                      <e-input-number
                                        v-show="dcYn != 'Y'"
                                        id="kmtcOn40"
                                        @input="setCalcuData()"
                                        style="width: 145px; margin-left:5px; height: 33px;"
                                        v-model="params.kmtcOn40"
                                        maxlength="50"
                                        placeholder="Enter your Target Rate"
                                      />
                                      <a v-show="dcYn == 'Y'" style="font-weight: 400; font-size: large; color: #075bb9;">USD {{ calcuAmt.kmtcFrom40 }}</a>
                                      <a style="font-weight: 400; font-size: medium; color: #075bb9;"> / FEU</a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr style="border: solid 5px #F0F5FF;">
                      <td colspan="2" style="border: solid 5px #F0F5FF;">
                        <a id="kmtcOnApply" style="height: 32px; width: 96.5%;" class="button blue lg" href="#" @click.prevent="kmtcOnNegoRequest()">{{ $t('msg.FARE010T010_NEW.038') }}</a><!-- 적용 -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-show="false" class="content_box mt10">
              <div class="mt10 ml10 mb10">
                <div>
                  <a style="font-size: 16px; font-weight: 400;">{{ $t('msg.FARE010T010_NEW.039') }}</a>
                </div>
                <div>
                  <a style="font-size: 20px; color: #075bb9; font-weight: 500;">{{ eyInfo.content1 }}</a>
                </div>
                <div>
                  <a style="font-size: 10px; font-weight: 300;">{{ eyInfo.content2 }}</a>
                </div>
              </div>
            </div>
            <div v-show="tapStatus === 1 && searchYn && couponGPList.length > 0" class="content_box mt10">
              <div @click.prevent="showCpDetail()" style="cursor: pointer;" class="ml25">
                <li style="font-size: 16px; color: #075bb9; font-weight: 500;">추가 할인 혜택</li>
                <a style="white-space: pre-line; display: contents; font-size: 14px; color: #075bb9;">선적 완료 후 정산 시, 조건을 충족한 경우 적용</a>
                <div style="margin-top: -15px; float: right;">
                  <a style="font-size: small; color: #075bb9;"> 자세히 보기 <a v-show="cpDetailYn !== 'Y'" class="tbl_icon new_plus"></a><a v-show="cpDetailYn === 'Y'" class="tbl_icon new_minus"></a></a>
                </div>
              </div>
              <div v-show="cpDetailYn === 'Y'">
                <div class="content_box mt10">
                  <div style="margin-left: 26px;">
                    <li style="font-size: 16px; color: #075bb9; font-weight: 500;">최대 혜택을 확인하세요!</li>
                    <a style="white-space: pre-line; display: contents; font-size: 14px; color: #075bb9;">아래 쿠폰을 선택하면 받을 수 있는 최대 할인 금액을 미리 계산해드립니다.</a>
                  </div>
                </div>
                <div v-for="(row,idx) in couponGPList" :key="idx" style="width: 100%;">
                  <table style="width: 100%;">
                    <tr>
                      <td :style="[couponGPList[idx] !== undefined ? {'width': '49%'} : {'width': '100%'}]">
                        <label :for="row.couponNo" style="width: 100%; cursor: pointer;">
                          <table style="margin-top: 10px; width: 100%; border: 1px solid #C7DAFF; border-radius: 4px; border-style: hidden; box-shadow: 0 0 0 1px rgb(201, 203, 214);">
                            <tr>
                              <th style="padding-left: 15px; border-top-left-radius: 4px; border-top-right-radius: 4px; height: 50px; font-weight: 500; background-color: #F0F5FF; color: black;">
                                <div class="flex_box">
                                  <div style="width: 70%;">
                                    <span>
                                      <input @change="setCalcuData(row.couponTyp === '05' ? '' : row.couponNo)" type="checkbox" :id="row.couponNo" v-model="row.chk" true-value="1" false-value="0" />
                                      <label :for="row.couponNo">
                                        <div>
                                          <a style="font-weight: 400; font-size: 12px; ">{{ row.content1 }}</a>
                                          <span style="font-weight: 500; font-size: 15px; ">{{ row.couponNm }}</span>
                                        </div>
                                      </label>
                                    </span>
                                  </div>
                                  <div class="flex_box" style="justify-content: end; width: 30%;">
                                    <div v-show="row.of20Rate > 0" class="content_box mr10" style="padding-top: 3px; height: 30px; width: fit-content;">
                                      <div style="width: 100%;">
                                        <a style="font-weight: 500; font-size: 10px;">20'  </a>
                                        <a style="font-weight: 600; font-size: 13px;">-${{ row.of20Rate }}</a>
                                      </div>
                                    </div>
                                    <div v-show="row.of40Rate > 0" class="content_box mr10" style="padding-top: 3px; height: 30px; width: fit-content;">
                                      <a style="font-weight: 500; font-size: 10px;">40' </a>
                                      <a style="font-weight: 600; font-size: 13px;">-${{ row.of40Rate }}</a>
                                    </div>
                                  </div>
                                </div>
                              </th>
                            </tr>
                            <tr style="height: 100px;">
                              <td style="border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; background-color: white; border-right: 0px; height: 33px;">
                                <table style="width: 100%;">
                                  <tbody>
                                    <tr>
                                      <td style="padding-right: 15px; padding-left: 15px;">
                                        <div>
                                          <a style="font-weight: 400; font-size: 12px;">{{ row.content4 }}</a>
                                        </div>
                                        <div>
                                          <a style="font-weight: 400; font-size: 12px;">{{ row.content3 }}</a>
                                        </div>
                                        <div>
                                          <a style="font-weight: 400; font-size: 12px;">{{ row.content2 }}</a>
                                        </div>
                                        <div>
                                          <a style="font-weight: 400; font-size: 10px;">{{ row.title }}</a>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </label>
                      </td>
                    </tr>
                  </table>
                </div>
                <div style="margin-top: 10px;">
                  <a style="white-space: pre-line; display: contents; font-size: 14px;">ⓘ 쿠폰 할인은 확정 운임이 아닙니다. 선적 완료 후 정산 시, 각 쿠폰의 조건을 충족한 경우에만 적용됩니다.</a>
                </div>
              </div>
            </div>
          </td>
          <td style="align-content: flex-start;">
            <div id="calcu">
              <div style="padding: 8px; width: 295px;" class="content_box mt10 ml10" v-show="searchYn && kmtcSpotCoupon === 'Y'">
                <!-- <a>계산기</a> -->
                <div v-show="tapStatus === 1" class="flex_box" style="float: right;">
                  <div style="display: flex; width: 37%; flex-direction: row-reverse;">
                    <div v-show="showFree" class="tooltip_wrap short position_absolute" style="background-color: #F0F5FF; width:685px; left:-650px; top:31px; padding-bottom: 11px;">
                      <div style="font-size: large;" class="mt15 ml15">
                        <th style="text-align: center;">Free Time</th>
                      </div>
                      <button style="right:16px; top:17px;" type="button" class="close" @click="showFree = false">close</button>
                      <div class="cont" style="padding: 0px; margin-right: 10px;">
                        <ul class="bul_list_sm t2">
                          <div class="content_box mt10 ml10" style="padding: 10px;">
                            <p class="port" style="height: 36px; font-size: large;">
                              <span>{{ params.polNm }}</span>
                              <span style="background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 11px;">{{ params.podNm }}</span>
                              <a style="display: list-item; margin-left: 25px; margin-top: 6px; float: right; font-size: small; color: black;" v-if="this.startDtGP !== ''">Freight Validity Period : {{ this.startDtGP }} ~ {{ this.endDtGP }}</a>
                            </p>
                            <div class="content_box" style="padding: 10px; background-color: #F0F5FF;">
                              <table class="tbl_col">
                                <colgroup>
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                </colgroup>
                                <thead>
                                  <tr>
                                    <th style="color: black; background-color: #E5EEFF;" rowspan="2">KIND</th>
                                    <th style="color: black; background-color: #E5EEFF;" colspan="2">Loading</th>
                                    <th style="color: black; background-color: #E5EEFF;" colspan="2">Discharging</th>
                                  </tr>
                                  <tr>
                                    <th style="color: black; background-color: #E5EEFF; border-left:1px solid #e1e3eb;">GP</th>
                                    <th style="color: black; background-color: #E5EEFF;">HC</th>
                                    <th style="color: black; background-color: #E5EEFF;">GP</th>
                                    <th style="color: black; background-color: #E5EEFF;">HC</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row,idx) in rateFreeDdsGPList" :key="idx">
                                    <td class="text_left">{{ row.demDetCatNm }}</td>
                                    <td>{{ row.ldGpFreeDds }}</td>
                                    <td>{{ row.ldHcFreeDds }}</td>
                                    <td>{{ row.disGpFreeDds }}</td>
                                    <td>{{ row.disHcFreeDds }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </ul>
                      </div>
                      <div style="text-align: center;" class="mt10">
                        <button style="width:100px; color:white; background-color: black" type="button" class="button" @click="showFree = false">Close</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="tapStatus === 2" class="flex_box" style="float: right;">
                  <div style="display: flex; width: 37%; flex-direction: row-reverse;">
                    <div v-show="showFree" class="tooltip_wrap short position_absolute" style="background-color: #F0F5FF; width:685px; left:-650px; top:31px; padding-bottom: 11px;">
                      <div style="font-size: large;" class="mt15 ml15">
                        <th style="text-align: center;">Free Time</th>
                      </div>
                      <button style="right:16px; top:17px;" type="button" class="close" @click="showFree = false">close</button>
                      <div class="cont" style="padding: 0px; margin-right: 10px;">
                        <ul class="bul_list_sm t2">
                          <div class="content_box mt10 ml10" style="padding: 10px;">
                            <p class="port" style="height: 36px; font-size: large;">
                              <span>{{ params.polNm }}</span>
                              <span style="background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 11px;">{{ params.podNm }}</span>
                              <a style="display: list-item; margin-left: 25px; margin-top: 6px; float: right; font-size: small; color: black;" v-if="this.startDtRF !== ''">Freight Validity Period : {{ this.startDtRF }} ~ {{ this.endDtRF }}</a>
                            </p>
                            <div class="content_box" style="padding: 10px; background-color: #F0F5FF;">
                              <table class="tbl_col">
                                <colgroup>
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="20%">
                                </colgroup>
                                <thead>
                                  <tr>
                                    <th style="color: black; background-color: #E5EEFF;" rowspan="2">KIND</th>
                                    <th style="color: black; background-color: #E5EEFF;" colspan="2">Loading</th>
                                    <th style="color: black; background-color: #E5EEFF;" colspan="2">Discharging</th>
                                  </tr>
                                  <tr>
                                    <th style="color: black; background-color: #E5EEFF; border-left:1px solid #e1e3eb;">RF</th>
                                    <th style="color: black; background-color: #E5EEFF;">RH</th>
                                    <th style="color: black; background-color: #E5EEFF;">RF</th>
                                    <th style="color: black; background-color: #E5EEFF;">RH</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row,idx) in rateFreeDdsRFList" :key="idx">
                                    <td class="text_left">{{ row.demDetCatNm }}</td>
                                    <td>{{ row.ldGpFreeDds }}</td>
                                    <td>{{ row.ldHcFreeDds }}</td>
                                    <td>{{ row.disGpFreeDds }}</td>
                                    <td>{{ row.disHcFreeDds }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </ul>
                      </div>
                      <div style="text-align: center;" class="mt10">
                        <button style="width:100px; color:white; background-color: black" type="button" class="button" @click="showFree = false">Close</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex_box">
                  <div>
                    <a style="font-weight: 500;"><span class="tbl_icon new_note"></span>{{ $t('msg.FARE010T010_NEW.053') }}</a>
                  </div>
                  <div style="width: 50%;">
                    <a v-if="calcuAmt.kmtcOn20 + calcuAmt.kmtcOn40 > 0" style="font-weight: 400; font-size: smaller; color: rgb(7, 91, 185); display: flex; width: 100%; flex-direction: row-reverse;">✓ 금액 협상 완료</a>
                  </div>
                </div>
                <div style="padding: 7px; align-content: center; text-align: center; background-color: rgba(246, 249, 255);" class="content_box mb10">
                  <div v-show="v20Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 60%;">
                        <th style="font-weight: 400;">20' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="width: 100%">
                        <div style="margin-right: 4px; display: flex; width: 100%; flex-direction: row-reverse;">
                          <a style="font-weight: 400;">&nbsp;${{ calcuAmt.from20 - calcuAmt.kmtcOn20 }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="v40Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 60%;">
                        <th style="font-weight: 400;">40' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="width: 100%">
                        <div style="margin-right: 4px; display: flex; width: 100%; flex-direction: row-reverse;">
                          <a style="font-weight: 400;">&nbsp;${{ calcuAmt.from40 - calcuAmt.kmtcOn40 }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="vHZYn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 50%;">
                        <th style="color:crimson; font-weight: 400;">20' HZ</th>
                      </div>
                      <div style="display: flex; width: 100%; flex-direction: row-reverse;">
                        <a style="font-weight: 400;">&nbsp;${{ calcuAmt.hzFrom20 }}</a>
                      </div>
                    </div>
                  </div>
                  <div v-if="vHZYn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 50%;">
                        <th style="color:crimson; font-weight: 400;">40' / HC HZ</th>
                      </div>
                      <div style="display: flex; width: 100%; flex-direction: row-reverse;">
                        <a style="font-weight: 400;">&nbsp;${{ calcuAmt.hzFrom40 }}</a>
                      </div>
                    </div>
                  </div>
                  <div style="border-bottom: ridge; padding: 3px;">
                  </div>
                  <div style="text-align: left;">
                    <a style="white-space: pre-line; display: contents; font-size: 12px;">✓ 운임 파일 생성 시 적용되는 금액입니다</a>
                  </div>
                </div>
              </div>
              <div style="padding: 8px; width: 295px;" class="content_box mt10 ml10" v-show="tapStatus === 1 && searchYn && couponGPList.length > 0 && kmtcSpotCoupon === 'Y'">
                <th style="font-weight: 500;"><span class="tbl_icon new_note"></span>추가 할인 혜택</th>
                <div v-show="calcuAmt.coup20+calcuAmt.lightC <= 0 && calcuAmt.coup40+calcuAmt.lightC40 <= 0" class="content_box" style="height: 105px; align-content: center; text-align: center; font-size: 12px;">
                  <a>좌측에서 쿠폰을 선택하여<br>추가 혜택을 확인하세요</a>
                </div>
                <div v-show="calcuAmt.coup20+calcuAmt.lightC > 0 || calcuAmt.coup40+calcuAmt.lightC40 > 0" style="padding: 7px; align-content: center; text-align: center; background-color: rgba(246, 249, 255);" class="content_box">
                  <div class="flex_box mb10">
                    <div>
                      <th style="font-weight: 400;">예상 최대 할인 금액</th>
                    </div>
                  </div>
                  <div v-show="v20Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 70%;">
                        <th style="font-weight: 400;">20' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="display: flex; width: 30%; flex-direction: row-reverse;">
                        <a style="font-size: smaller; font-weight: 400;">$ {{ calcuAmt.coup20+calcuAmt.lightC }}</a>
                      </div>
                    </div>
                  </div>
                  <div v-show="v40Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 70%;">
                        <th style="font-weight: 400;">40' / HC {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="display: flex; width: 30%; flex-direction: row-reverse;">
                        <a style="font-size: smaller; font-weight: 400;">$ {{ calcuAmt.coup40+calcuAmt.lightC40 }}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="calcuAmt.coup20+calcuAmt.lightC > 0 || calcuAmt.coup40+calcuAmt.lightC40 > 0" style="margin-top: 10px; padding: 7px; align-content: center; text-align: center; background-color: rgba(246, 249, 255);" class="content_box">
                  <div class="flex_box mb10">
                    <div>
                      <th style="font-weight: 400;">쿠폰 적용 시 예상 최저가</th>
                    </div>
                  </div>
                  <div v-show="v20Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 70%;">
                        <th style="font-weight: 400;">20' {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="display: flex; width: 30%; flex-direction: row-reverse;">
                        <a style="font-size: smaller; font-weight: 400;">$ {{ calcuAmt.to20 }}</a>
                      </div>
                    </div>
                  </div>
                  <div v-show="v40Yn" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding: 7px;" class="content_box">
                    <div class="flex_box">
                      <div style="width: 70%;">
                        <th style="font-weight: 400;">40' / HC {{ $t('msg.FARE010T010_NEW.027') }}</th>
                      </div>
                      <div style="display: flex; width: 30%; flex-direction: row-reverse;">
                        <a style="font-size: smaller; font-weight: 400;">$ {{ calcuAmt.to40 }}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content_box mt10" style="border-color: red; text-align: left;">
                  <a style="color: red; white-space: pre-line; display: contents; font-size: 14px;">⚠ </a>
                  <a style="white-space: pre-line; display: contents; font-size: 12px;">쿠폰 조건 충족 시에만 적용</a>
                </div>
              </div>
              <div style="margin-top: 10px; margin-left: 10px; width: 273px;" v-show="searchYn">
                <a id="raBtn" style="height: 32px; width: 96.5%;" class="button blue lg" href="#" @click.prevent="saveFreightQuotation">{{ $t('msg.FARE010T010_NEW.052') }}</a>
              </div>
              <div style="margin-top: 5px; margin-left: 10px; width: 273px;" v-show="searchYn">
                <a id="bkgBtn" style="height: 35px; width: 96.5%;" class="button grey lg" href="#" @click.prevent="goBooking()">Booking</a><!-- Booking -->
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="background-color: rgb(246, 249, 255); padding: 5px; border-radius: 0px; border-color: white; position: fixed; z-index: 101; width: 100%; bottom: 0px; left: 0px;" class="content_box" v-show="false">
      <div class="flex_box" style="margin-left: 8%; text-align: right; height: 45px; font-size: x-large;">
        <a style="color: black; border-color: black; cursor: unset; height: 35px; width: 99px; border-radius: 50px; align-content: center; font-size: large; font-weight: 600;" class="button grey lg">예상 운임</a>
        <div style="width: 937px; text-align: left;">
          <a v-show="v20Yn" style="color: black; border-color: black; cursor: unset; height: 35px; width: 150px; border-radius: 50px; align-content: center; font-size: large; margin-left: 10px; font-weight: 600;" class="button grey lg">20' $ {{ calcuAmt.to20 }} / TEU</a>
          <a v-show="v20Yn && vHZYn" style="color: black; border-color: black; cursor: unset; height: 35px; width: 200px; border-radius: 50px; align-content: center; font-size: large; margin-left: 10px; font-weight: 600;" class="button grey lg">20' HZ $ {{ calcuAmt.hzTo20 }} / TEU</a>
          <a v-show="v40Yn" style="color: black; border-color: black; cursor: unset; height: 35px; width: 150px; border-radius: 50px; align-content: center; font-size: large; margin-left: 10px; font-weight: 600;" class="button grey lg">40' $ {{ calcuAmt.to40 }} / FEU</a>
          <a v-show="v40Yn && vHZYn" style="color: black; border-color: black; cursor: unset; height: 35px; width: 200px; border-radius: 50px; align-content: center; font-size: large; margin-left: 10px; font-weight: 600;" class="button grey lg">40' HZ $ {{ calcuAmt.hzTo40 }} / FEU</a>
        </div>
        <a style="margin-right: 1%;">|</a>
        <a id="raBtn" style="height: 35px; width: 100px; border-radius: 50px; align-content: center; font-size: large;" class="button blue lg" href="#" @click.prevent="saveFreightQuotation">운임확인</a><!-- 견적확인 -->
        <a id="bkgBtn" style="height: 35px; width: 100px; border-radius: 50px; align-content: center; font-size: large; margin-right: 15%; margin-left: 10px;" class="button grey lg" href="#" @click.prevent="goBooking()">Booking</a><!-- Booking -->
      </div>
    </div>
  </div>
</template>

<script>
import commons from '@/api/services/commons'
import { rootComputed } from '@/store/helpers'
import print from 'vue-print-nb'

import schedule from '@/api/rest/schedule/schedule'
import mySchedules from '@/api/rest/schedule/mySchedule'
import vslScheduleInfo from '@/api/rest/schedule/vslScheduleInfo'
import apiCompare from '@/api/rest/schedule/compare'
import EInputNumber from '@/components/common/EInputNumber'

export default {
  name: 'ShippingCostInquiryNew',
  directives: {
    print
  },
  components: {
    EInputNumber,
    'win-layer-pop': () => import('@/pages/trans/popup/WinLayerPop'),
    'fre-surcharge-pop': () => import('@/pages/schedule/popup/FreSurchargePop'),
    'fre-surcharge-pop2': () => import('@/pages/schedule/popup/FreSurchargePop2'),
    'request-quote-pop': () => import('@/pages/schedule/popup/RequestQuotePop'),
    'e-auto-complete-place': () => import('@/components/common/EAutoCompletePlace'),
    'e-date-picker': () => import('@/components/common/EDatePicker')
  },
  data () {
    return {
      showFavor: false,
      showHisto: false,
      showFree: false,
      customComponent: null,
      searchYn: false,
      isFixed: false,
      myScheduleList: [],
      recentScheduleList: [],
      schId: 0,
      userCtrCd: 'KR',
      myScheduleOrNot: '',
      v20Yn: true,
      v40Yn: true,
      vHZYn: false,
      cntr20Yn: '1',
      cntr40Yn: '1',
      cntrHzYn: '0',
      sales20Rate: 0,
      sales40Rate: 0,
      tapStatus: 1,
      frtAppNo: '',
      apv20FtList: [],
      apv40FtList: [],
      myOceanFreightList: [],
      // surChargeList: [],
      surChargeListDry: [],
      surChargeListRee: [],
      surChargeListFlat: [],
      surChargeListTank: [],
      surChargeListEtc: [],
      surChargeNoteGPList: [],
      surChargeNoteRFList: [],
      surChargeListOT: [],
      containerType: [],
      rateFreeDdsGPList: [],
      rateFreeDdsRFList: [],
      couponGPList: [],
      couponRFList: [],
      containerTypeCode: '',
      frtAppNoGP: '',
      frtAppNoRF: '',
      startDtGP: '',
      endDtGP: '',
      startDtRF: '',
      endDtRF: '',
      of20Rate: '',
      of40Rate: '',
      schgReqRnoGP: '',
      schgReqRnoRF: '',
      frtPncCd: '',
      dcYn: '',
      eyYn: 'N',
      saveShprNm: '',
      kmtcOnNowNoticeMsg: '',
      kmtcOnNowNoticeSubMsg: '',
      kmtcOnNowDisabledYn: 'N',
      params: {
        // [s] 검색조건 ==============================
        // 출발 국가
        porCtrCd: '',
        // 출발 지역
        porPlcCd: '',
        // 출발국가 명
        polCtrNm: '',
        // 출발지 명
        polNm: '',
        // 도착 국가
        dlyCtrCd: '',
        // 도착 지역
        dlyPlcCd: '',
        // 도착국가 명
        podCtrNm: '',
        // 도착지 명
        podNm: '',
        // 예상 출항일
        etd: '',
        // Freight Term(Prepaid(P)/Collect(C))
        frtTerm: 'P',
        // 실화주 코드
        bkgShprCstNo: '',
        // 수-출입 구분 코드
        eiCatCd: '',
        // [e] 검색조건 ==============================

        // 영업사원 정보
        salNm: '',
        salTelNo: '',
        salUno: '',
        salEmlAddr: '',
        freightMenuchk: 'Y',
        cntrTypCd: '',
        hotDealYn: '',
        frtResult: '',
        frtAppNo: '',
        freAppNoList: [],
        reqRno: '',
        reqRnoGP: '',
        reqRnoRF: '',
        startDt: '',
        endDt: '',
        kmtcSpotUserYn: '',
        ofCntrSize01: '',
        ofCntrSize02: '',
        ofDcRate01: '',
        ofDcRate02: '',
        dtCntrSize01: '',
        dtCntrSize02: '',
        dtDcRate01: '',
        dtDcRate02: '',
        cpDcReqRno: '',
        lcDcYn: '0',
        kmtcOnShprNm: '',
        kmtcOn20: '',
        kmtcOn40: ''
      },
      // 운임 팝업을 띄우기 위해 필요한 데이터
      searchPolNm: '',
      searchPodNm: '',
      surChargeParams: {},
      kmtcSpotUserYn: 'N',
      kmtcSpotCoupon: 'N',
      relYn: true, // JamSin,
      detailYn: 'N',
      cpDetailYn: 'N',
      setCntrTyp: '',
      gpCpYn: '0',
      rfCpYn: '0',
      fastBkgYn: '0',
      lowWeightBkgYn: '0',
      eyInfo: {
        content1: '',
        content2: ''
      },
      coupInfo: {
        lcDcRate20: 0,
        lcDcRate40: 0,
        of20RateGP: 0,
        of40RateGP: 0,
        of20RateRF: 0,
        of40RateRF: 0
      },
      calcuAmt: {
        kmtcFrom20: 0,
        kmtcFrom40: 0,
        kmtcOn20: 0,
        from20: 0,
        to20: 0,
        kmtcOn40: 0,
        from40: 0,
        to40: 0,
        coup20: 0,
        coup40: 0,
        earlyB: 0,
        lightC: 0,
        lightC40: 0,
        hzFrom20: 0,
        hzFrom40: 0,
        hzTo20: 0,
        hzTo40: 0
      }
    }
  },
  created () {
    for (const type of ['click']) {
      window.addEventListener(type, this.customEvent)
    }

    // 로그인한 경우 KMTC SPOT 대상 조회
    if (this.auth.login) {
      this.getKmtcSpotTarget()
    }

    if (Object.keys(this.$route.query).length > 0) {
      const vo = this.$route.query

      this.params.porPlcCd = vo.porPlcCd
      this.params.porCtrCd = vo.porCtrCd
      this.params.dlyPlcCd = vo.dlyPlcCd
      this.params.dlyCtrCd = vo.dlyCtrCd
      this.params.etd = vo.etd

      this.params.polNm = vo.polNm
      this.params.podNm = vo.podNm

      this.fnSearchSurCharge()
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('keydown', this.handleKeydown)
    })
    document.addEventListener('scroll', this.scroll)
    this.initLeg()
    this.getMyHistory()

    $('.footer').addClass('hidden')
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleKeydown)
    $('.footer').removeClass('hidden')
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.scroll)
  },
  computed: {
    ...rootComputed
  },
  watch: {
    'params.etd' () {
      this.$nextTick(() => {
        this.fnValidationEtd()
      })
    }
  },
  methods: {
    selectTab (tab) {
      $('.content_box .tab li').removeClass('on')

      $('.content_box #tab' + tab).addClass('on')

      this.tapStatus = tab
      this.setCalcuData()
      this.setKmtcOnNowNotice()
    },
    getMyHistory () {
      const params = {
        cnt: 5,
        pol: '',
        pod: ''
      }
      apiCompare.getMyHistory(params)
        .then(response => {
          if (response.data) {
            const tmp = response.data.map(d => {
              return {
                ...d,
                chk: false
              }
            })
            this.recentScheduleList = tmp
          }
        })
    },
    selectMySchedule (list) {
      this.params.porCtrCd = list.polCn
      this.params.porPlcCd = list.polCd === 'PNC' ? 'PUS' : list.polCd
      this.params.polCtrNm = list.polNm
      this.params.polNm = list.polNm2
      this.params.dlyCtrCd = list.podCn
      this.params.dlyPlcCd = list.podCd === 'PNC' ? 'PUS' : list.podCd
      this.params.podCtrNm = list.podNm
      this.params.podNm = list.podNm2
    },
    selectRecentSchedule (list) {
      this.params.porCtrCd = list.polCtrCd
      this.params.porPlcCd = list.polPortCd === 'PNC' ? 'PUS' : list.polPortCd
      this.params.polCtrNm = list.polCtrNm
      this.params.polNm = list.polPortNm
      this.params.dlyCtrCd = list.podCtrCd
      this.params.dlyPlcCd = list.podPortCd === 'PNC' ? 'PUS' : list.podPortCd
      this.params.podCtrNm = list.podCtrNm
      this.params.podNm = list.podPortNm
    },
    fnAddMySchedule () {
      const params = {
        startPolCn: this.params.porCtrCd,
        startPolCd: this.params.porPlcCd,
        startCtrNm: '',
        startPlcNm: this.params.polNm,
        destPodCn: this.params.dlyCtrCd,
        destPodCd: this.params.dlyPlcCd,
        destCtrNm: '',
        destPlcNm: this.params.podNm
      }
      mySchedules.addMySchedule(params).then((resultCode) => {
        if (resultCode.data.result === 1) {
          mySchedules.getMySchedule().then((rtnData) => {
            this.myScheduleList = rtnData.data.mySchedule
          })
          mySchedules.checkMySchedule(params).then((rtnMySchData) => {
            this.myScheduleOrNot = rtnMySchData.data.myScheduleOrNot
            this.schId = rtnMySchData.data.schId
          })
        }
      })
      // this.myScheduleOrNot = 'Y'
    },
    deleteMyScheduleStar (schId) {
      mySchedules.deleteMySchedule(schId).then((resultCode) => {
        if (resultCode.data.result === 1) {
          mySchedules.getMySchedule().then((rtnData) => {
            this.myScheduleList = rtnData.data.mySchedule
          })
        }
      })
      this.myScheduleOrNot = 'N'
    },
    async initLeg () {
      if (this.auth.userId !== '') {
        const list = await mySchedules.getMySchedule()
        this.myScheduleList = list.data.mySchedule
      }
    },
    scroll () {
      if (window.scrollY > this.$refs.headerXPos.offsetTop - 50) {
        this.isFixed = true
        if (this.searchYn) {
          $('#calcu').addClass('float_calcu_box')
        }
      } else {
        this.isFixed = false
        $('#calcu').removeClass('float_calcu_box')
      }
    },
    handleKeydown (e) {
      // JamSin
      if (this.relYn) {
        if (e.key === 'Enter') {
          this.fnSearchSurCharge()
        }
      }
    },
    // '출발' 자동완성 change event
    changePol (vo) {
      this.params.porCtrCd = vo.ctrCd
      this.params.porPlcCd = vo.plcCd
      this.params.polCtrNm = vo.ctrEnm
      this.params.polNm = vo.plcNm
      const frm = document.querySelector('#frm')
      const elem = frm.querySelector('#polPol')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    // '도착' 자동완성 change event
    changePod (vo) {
      this.params.dlyCtrCd = vo.ctrCd
      this.params.dlyPlcCd = vo.plcCd
      this.params.podCtrNm = vo.ctrEnm
      this.params.podNm = vo.plcNm
      const frm = document.querySelector('#frm')
      const elem = frm.querySelector('#podPod')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    // 영업사원 설정
    async fnSalUnoSet () {
      const porCd = this.params.porCtrCd
      const dlyCd = this.params.dlyCtrCd

      if (this.$ekmtcCommon.isEmpty(porCd) || this.$ekmtcCommon.isEmpty(dlyCd)) {
        return
      }

      const tmpParam = {
        porCd: porCd,
        dlyCd: dlyCd
      }

      await schedule.findSalUno(tmpParam).then((response) => {
          console.log('response @@@@@ ', response)

          if (response.status === 200) {
            const respData = response.data

            if (respData.eiCatCd !== undefined) {
              this.params.eiCatCd = respData.eiCatCd

              const eiCatCd = this.params.eiCatCd
              if (eiCatCd === 'O' || eiCatCd === 'OJ' || eiCatCd === 'OJRF') {
                this.params.frtTerm = 'P'
              } else if (eiCatCd === 'I') {
                this.params.frtTerm = 'C'
              }
            }
            if (respData.salNm !== undefined) {
              this.params.salNm = respData.salNm
            }
            if (respData.salTelNo !== undefined) {
              this.params.salTelNo = respData.salTelNo
            }
            if (respData.salUno !== undefined) {
              this.params.salUno = respData.salUno
            }
            if (respData.salEmlAddr !== undefined) {
              this.params.salEmlAddr = respData.salEmlAddr
            }
          }
        })
    },
    async getCntrTypeMessage () {
      let message = this.$t('msg.CSCT060G040.010') + '<br><br>'

      message += '<div class="d_flex">'
      message += '  <div class="inp_space30">Type : </div>'
      message += '  <div class="inp_space70">'
      message += '  <select id="popCntrTypCd">'
      message += '  <option value="">' + this.$t('msg.CSBL200.075') + '</option>'
      message += '  <option value="GP">Dry</option>'
      message += '  <option value="RF">Reefer</option>'
      message += '  <option value="FR">Flat Rack</option>'
      message += '  <option value="OT">Open Top</option>'
      message += '  </select>'
      message += '  </div>'
      message += '</div>'

      let rtnVal = ''
      const isOk = await this.$ekmtcCommon.asyncAlertMessage({
        message: message,
        useConfirmBtn: true,
        onConfirmSelf: (resolve, $Simplert) => {
          const popCntrTypCd = document.querySelector('#popCntrTypCd')

          if (this.$ekmtcCommon.isEmpty(popCntrTypCd.value)) {
            this.$ekmtcCommon.showErrorTooltip(popCntrTypCd, this.$t('msg.CSBK100.147'))
          } else {
            rtnVal = popCntrTypCd.value
            resolve(true)
            $Simplert.close()
          }
        }
      })

      return {
        isOk: isOk,
        rtnVal: rtnVal
      }
    },
    async fnFrtConfirm () {
      const params = this.params
      const reqParams = {
        porCtrCd: params.porCtrCd,
        porPlcCd: params.porPlcCd,
        dlyCtrCd: params.dlyCtrCd,
        dlyPlcCd: params.dlyPlcCd,
        etd: params.etd,
        eiCatCd: params.eiCatCd
      }

      const cntrMsgInfo = await this.getCntrTypeMessage()

      if (cntrMsgInfo.isOk) {
        reqParams.cntrTypCd = cntrMsgInfo.rtnVal
        this.params.cntrTypCd = cntrMsgInfo.rtnVal

        await schedule.fnPopFreReq(reqParams).then((response) => {
          const result = response.data.insertRateMngResult
          let msg = ''
          if (result !== undefined && result === 1) {
            //msg = this.$t('msg.FARE010T010_NEW.022') // 문의하신 구간에 대한 운임등록 요청이 접수되었습니다. 잠시 후에 다시 확인하시기 바랍니다.
            msg = this.$t('msg.FARE010T010_NEW.025') // 현재 요청하신 기간 및 구간에 등록된 운임이 없습니다.

            const confirmOpt = {
              alertType: 'simple',
              customCloseBtnText: this.$t('msg.VOSD100_M5.004'), // 닫기
              customConfirmBtnText: this.$t('msg.VOSD100_M5.003'), // 확인
              useConfirmBtn: true,
              message: `${this.$t('msg.FARE010T010_NEW.025')}\n${this.$t('msg.FARE010T010_NEW.026')}`, // 현재 요청하신 기간 및 구간에 등록된 운임이 없습니다.\n영업 사원에게 문의 하시겠습니까?
              onConfirm: this.sendSalEmail
            }

            this.$ekmtcCommon.alert(confirmOpt)
          } else if (result !== undefined && result === 2) { // 등록된 운임이 있음
            msg = this.$t('msg.FARE010T010_NEW.024')
            this.$ekmtcCommon.alertDefault(msg)
          } else if (result !== undefined && result === 3) { // 요청중인 내역이 있는경우 메시지만 동일하게 출력
            //msg = this.$t('msg.FARE010T010_NEW.022') // 문의하신 구간에 대한 운임등록 요청이 접수되었습니다. 잠시 후에 다시 확인하시기 바랍니다.
            msg = this.$t('msg.FARE010T010_NEW.025') // 현재 요청하신 기간 및 구간에 등록된 운임이 없습니다.

            const confirmOpt = {
              alertType: 'simple',
              customCloseBtnText: this.$t('msg.VOSD100_M5.004'), // 닫기
              customConfirmBtnText: this.$t('msg.VOSD100_M5.003'), // 확인
              useConfirmBtn: true,
              message: `${this.$t('msg.FARE010T010_NEW.025')}\n${this.$t('msg.FARE010T010_NEW.026')}`, // 현재 요청하신 기간 및 구간에 등록된 운임이 없습니다.\n영업 사원에게 문의 하시겠습니까?
              onConfirm: this.sendSalEmail
            }

            this.$ekmtcCommon.alert(confirmOpt)
          } else {
            msg = this.$t('msg.FARE010T010_NEW.023') // 처리 중 오류가 발생하였습니다. 시스템 관리자에게 문의해 주세요.
            this.$ekmtcCommon.alertDefault(msg)
          }
        })
      }
    },
    // 운임 관련 담당 영업사원 이메일 전송
    sendSalEmail () {
      const param = {
        polCtrCd: this.params.porCtrCd,
        podCtrCd: this.params.dlyCtrCd,
        polPortCd: this.params.porPlcCd,
        podPortCd: this.params.dlyPlcCd,
        salEmlAddr: this.params.salEmlAddr,
        cntrTypCd: this.params.cntrTypCd,
        strDt: this.params.etd
      }

      schedule.sendSalEmail(param).then(async (response) => {
          console.log('sendSalEmail response @@@@@ ', response)

          if (response.headers.respmsg === 'SUCC') {
            this.$ekmtcCommon.alertDefault(this.$t('art.CMATK146')) // 메일이 전송되었습니다.
          } else {
            this.$ekmtcCommon.alertDefault(this.$t('mgs.SETT060G010.049')) // 전송에 실패했습니다.
          }
        })
        .catch(err => {
          console.log(err)
          this.$ekmtcCommon.alertDefault(this.$t('mgs.SETT060G010.049')) // 전송에 실패했습니다.
        })
    },
    getCntrList () {
      vslScheduleInfo.popFreRateNoCntr(this.params).then((rtnData) => {
        this.cntrTypList = rtnData.data.cntrTypList
        if (this.cntrTypList === undefined || this.cntrTypList.length === 0) {
          this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.ONEX010T010.073') }) // 검색 결과가 없습니다.
        }
        for (const item of this.cntrTypList) {
          if (item.cntrTypCd === 'GP') {
            if (this.setCntrTyp === 'GP' || this.setCntrTyp === 'ALL') {
              this.params.reqRno = item.reqRno
              this.params.reqRnoGP = item.reqRno
              this.cntrTypCd2 = item.cntrTypCd
              this.getFreSurcharge()
            }
          } else if (item.cntrTypCd === 'RF') {
            if (this.setCntrTyp === 'RF' || this.setCntrTyp === 'ALL') {
              this.params.reqRno = item.reqRno
              this.params.reqRnoRF = item.reqRno
              this.cntrTypCd2 = item.cntrTypCd
              this.getFreSurcharge()
            }
          }
        }
      })
    },
    // 운임 검색 ('확인'버튼 이벤트)
    async fnSearchReset () {
      this.params.etd = ''
      this.searchYn = false

      const vo = {
        ctrCd: ' ',
        plcCd: ' ',
        ctrEnm: ' ',
        plcNm: ' '
      }
      this.changePol(vo)
      this.changePod(vo)
    },
    // 운임 검색
    async fnSearchSurCharge () {
      this.v20Yn = this.cntr20Yn === '1'
      this.v40Yn = this.cntr40Yn === '1'
      this.vHZYn = this.cntrHzYn === '1'
      this.searchPolNm = this.params.polNm
      this.searchPodNm = this.params.podNm
      await this.fnSalUnoSet()
      this.replaceCChargeList()

      this.setKmtcOnNowNotice()

      if (this.kmtcSpotCoupon === 'Y' && this.kmtcOnNowDisabledYn !== 'Y') {
        this.searchCouponList()
      }
      //검색조건 전체 validation check
      if (this.fnValidationAll()) {
        // R/A No 조회
        if (this.params.porCtrCd === 'US' || this.params.dlyCtrCd === 'US') {
            let usScNoYn = ''
            await vslScheduleInfo.popFreAppNoUsScList(this.params).then((rtnData) => {
              if (rtnData.data.surChargeList.length > 0) {
                usScNoYn = 'Y'
              }
            })
            if (usScNoYn !== 'Y' && this.memberDetail.userCtrCd !== 'CN') {
              const confirmOpt = {
                alertType: 'simple',
                customCloseBtnText: this.$t('msg.VOSD100_M5.004'), // 닫기
                customConfirmBtnText: this.$t('msg.VOSD100_M5.003'), // 확인
                useConfirmBtn: true,
                message: `${this.$t('msg.FARE010T010_NEW.025')}\n${this.$t('msg.FARE010T010_NEW.026')}`, // 현재 요청하신 기간 및 구간에 등록된 운임이 없습니다.\n영업 사원에게 문의 하시겠습니까?
                onConfirm: this.sendSalEmail
              }
              this.$ekmtcCommon.alert(confirmOpt)
              return
            }
          }
        await schedule.popFreAppNo(this.params).then(async (response) => {
          if (response.status === 200) {
            const respData = response.data

            const frtResult = this.$ekmtcCommon.isEmpty(respData.frtResult) ? '' : respData.frtResult
            const frtAppNo = this.$ekmtcCommon.isEmpty(respData.frtAppNo) ? '' : respData.frtAppNo
            const reqRno = this.$ekmtcCommon.isEmpty(respData.reqRno) ? '' : respData.reqRno
            const strDt = this.$ekmtcCommon.isEmpty(respData.strDt) ? '' : respData.strDt
            const endDt = this.$ekmtcCommon.isEmpty(respData.endDt) ? '' : respData.endDt

            this.params.frtResult = frtResult
            this.params.frtAppNo = frtAppNo
            this.frtAppNo = frtAppNo
            this.params.reqRno = reqRno
            this.params.startDt = strDt
            this.params.endDt = endDt
            this.params.kmtcSpotUserYn = this.kmtcSpotUserYn

            const oonlYn = this.memberDetail.oonlYn // 수출영업(Export) 기준으로 온라인 견적 대상 화주인 경우
            const jonlYn = this.memberDetail.jonlYn // 일본영업 기준으로 온라인 견적 대상 화주인 경우
            const ionlYn = this.memberDetail.ionlYn // 수입영업(Import) 기준으로 온라인 견적 대상 화주인 경우
            const oengOnlYn = this.memberDetail.oengOnlYn
            const userCtrCd = this.memberDetail.userCtrCd

            let rmPopOpenFlag = false

            // ****************************** [s] 온라인 견적 적용 조건 ******************************
            if (oonlYn === 'Y' && jonlYn === 'Y') {
              // 1) 수출영업(Export) 과 일본영업에 대해서 모두 온라인 견적 대상 화주인 경우
              if (this.params.porCtrCd === 'KR') {
                // POL (출발항) 에 KR 소재의 port 를 입력하면
                // 온라인 견적이 적용
                rmPopOpenFlag = true
              }
              if (this.params.porCtrCd === 'KR' && this.params.dlyCtrCd === 'JP') {
                rmPopOpenFlag = true
              }
              if (this.params.porCtrCd === 'JP' && this.params.dlyCtrCd === 'KR') {
                rmPopOpenFlag = true
              }
            } else {
              if (oonlYn === 'Y') {
                // 2) 수출영업(Export) 기준으로 온라인 견적 대상 화주인 경우
                if (this.params.porCtrCd === 'KR' && this.params.dlyCtrCd !== 'JP') {
                  // POL (출발항) 에 KR 소재의 port 를 입력하고
                  // POD (도착항) 에 JP (일본) 를 '제외한' 국가의 port 를 입력하는 경우에만
                  // 온라인 견적이 적용
                  rmPopOpenFlag = true
                }
              } else if (jonlYn === 'Y') {
                // 3) 일본영업 기준으로 온라인 견적 대상 화주인 경우
                if (this.params.porCtrCd === 'KR' && this.params.dlyCtrCd === 'JP') {
                  // 3-1)
                  // POL (출발항) 에 KR 소재의 port 를 입력하고
                  // POD (도착항) 에 JP (일본)의 port 를 입력하는 경우에만
                  // 온라인 견적이 적용
                  rmPopOpenFlag = true
                }
                if (this.params.porCtrCd === 'JP' && this.params.dlyCtrCd === 'KR') {
                  // 3-2)
                  // POL (출발항) 에 JP (일본) 의 port 를입력하고
                  // POD (도착항) 에 KR 소재의 port 를 입력하는 경우
                  // 온라인 견적이 적용
                  rmPopOpenFlag = true
                }
              }
            }

            if (ionlYn === 'Y') {
              if (this.params.porCtrCd !== 'JP' && this.params.dlyCtrCd === 'KR') {
                rmPopOpenFlag = true
              }
            }

            if (oengOnlYn === 'Y' && userCtrCd !== 'KR') {
              rmPopOpenFlag = true
            }
            // ****************************** [e] 온라인 견적 적용 조건 ******************************\
            if (frtResult === 'Y') {
              // ===========================================
              // [1] R/A No(Rate Application) 정보가 있는 경우
              // ===========================================

              await vslScheduleInfo.popFreAppNoList(this.params).then((rtnData) => {
                this.freAppNoList = rtnData.data.surChargeList
                let listOrNot = false
                const freAppNoGPList = []
                const freAppNoRFList = []
                for (const item of this.freAppNoList) {
                  if (item.cntrTypCd === 'GP') {
                    freAppNoGPList.push(item)
                  } else if (item.cntrTypCd === 'RF') {
                    freAppNoRFList.push(item)
                  }
                }
                if (freAppNoGPList.length > 0) {
                  for (const item of freAppNoGPList) {
                        this.params.frtAppNo = item.frtAppNo
                        this.params.cntrTypCd = item.cntrTypCd
                        this.params.hotDealYn = item.hotDealYn
                        this.startDateRM = item.strDt
                        this.endDateRM = item.obrdDt
                        this.dcYn = item.dcYn
                        listOrNot = true
                        this.startDtGP = this.dateFormat(item.strDt)
                        this.endDtGP = this.dateFormat(item.obrdDt)
                        this.frtAppNoGP = item.frtAppNo
                        this.getRAFreSurcharge()
                  }
                  this.raOrRm = 'RA'
                } else {
                  this.setCntrTyp = 'GP'
                  this.getCntrList()
                  this.raOrRm = 'RM'
                }

                if (freAppNoRFList.length > 0) {
                  for (const item of freAppNoRFList) {
                        this.params.frtAppNo = item.frtAppNo
                        this.params.cntrTypCd = item.cntrTypCd
                        this.params.hotDealYn = item.hotDealYn
                        this.startDateRM = item.strDt
                        this.endDateRM = item.obrdDt
                        this.dcYn = item.dcYn
                        listOrNot = true
                        this.startDtRF = this.dateFormat(item.strDt)
                        this.endDtRF = this.dateFormat(item.obrdDt)
                        this.frtAppNoRF = item.frtAppNo
                        this.getRAFreSurcharge()
                  }
                  this.raOrRm = 'RA'
                } else {
                  this.setCntrTyp = 'RF'
                  this.getCntrList()
                  this.raOrRm = 'RM'
                }
              })
              this.searchYn = true
              this.isFixed = false
              // 나의 스케줄
              const paramsMySch = {
                startPolCn: this.params.porCtrCd,
                startPolCd: this.params.porPlcCd,
                destPodCn: this.params.dlyCtrCd,
                destPodCd: this.params.dlyPlcCd
              }
              mySchedules.checkMySchedule(paramsMySch).then((rtnMySchData) => {
                this.myScheduleOrNot = rtnMySchData.data.myScheduleOrNot
                this.schId = rtnMySchData.data.schId
              })
            } else if (frtResult === 'A') {
              // =========================================================================
              // [2] R/A(Rate Application) 정보가 없고, R/M(Rate Management) 정보가 있는 경우
              // =========================================================================

              if (rmPopOpenFlag) {
                //----------------------------------------------------------------------------------------------------------
                // // 온라인 견적이 적용된 경우
                // this.surChargeParams = { ...this.surChargeParams, ...this.params }
                // // 운임확인 팝업창 호출시 콘솔로그에 발생하는 kmtcSpotUserYn 오류 발생 방지용 코드
                // this.surChargeParams.detailResp2 = Object.assign({}, this.surChargeParams.detailResp2, { kmtcSpotUserYn: this.kmtcSpotUserYn })
                // this.openPopup('fre-surcharge-pop2')
                //-------------------------------------------------------------------------------------------------------------
                this.searchYn = true
                this.isFixed = false
                // 나의 스케줄
                const paramsMySch = {
                  startPolCn: this.params.porCtrCd,
                  startPolCd: this.params.porPlcCd,
                  destPodCn: this.params.dlyCtrCd,
                  destPodCd: this.params.dlyPlcCd
                }
                mySchedules.checkMySchedule(paramsMySch).then((rtnMySchData) => {
                  this.myScheduleOrNot = rtnMySchData.data.myScheduleOrNot
                  this.schId = rtnMySchData.data.schId
                })
                this.setCntrTyp = 'ALL'
                this.getCntrList()
              } else {
                // 온라인 견적이 적용되지 않은 경우 - 일반화주
                // "문의하신 구간에 등록된 운임이 없습니다. 견적 문의를 요청하시겠습니까?" 팝업 띄움
                // 예 - 운임문의 팝업(SCHD010P080)
                // 아니오 - Alert 닫기

                const TH = this
                // 문의하신 구간에 등록된 운임이 없습니다. 견적 문의를 요청하시겠습니까?
                if (await TH.$ekmtcCommon.asyncAlertMessage({ message: TH.$t('msg.FARE010T010_NEW.021'), useConfirmBtn: true })) {
                  TH.surChargeParams = TH.params
                  TH.openPopup('request-quote-pop')
                }
              }
            } else if (frtResult === 'N') {
              // =================================================================
              // [3] R/A(Rate Application), R/M(Rate Management) 정보 모두 없는 경우
              // =================================================================

              if (rmPopOpenFlag) {
                // 온라인 견적이 적용된 경우
                this.fnFrtConfirm()
              } else {
                // 온라인 견적이 적용되지 않은 경우 - 일반화주
                // "문의하신 구간에 등록된 운임이 없습니다. 견적 문의를 요청하시겠습니까?" 팝업 띄움
                // 예 - 운임문의 팝업(SCHD010P080)
                // 아니오 - Alert 닫기

                const TH = this
                // 문의하신 구간에 등록된 운임이 없습니다. 견적 문의를 요청하시겠습니까?
                if (await TH.$ekmtcCommon.asyncAlertMessage({ message: TH.$t('msg.FARE010T010_NEW.021'), useConfirmBtn: true })) {
                  TH.surChargeParams = TH.params
                  TH.openPopup('request-quote-pop')
                }
              }
            }
          }
        })
      }
    },
    // R/A
    async getRAFreSurcharge () {
      let dry = 'N'
      let reefee = 'N'
      let flat = 'N'
      let tank = 'N'
      let ot = 'N'
      let cntrType = this.params.cntrTypCd

      // this.params.cntrTypCd = this.cntrTypCd2
      await vslScheduleInfo.getPopFreSurcharge(this.params).then((rtnData) => {
        this.surChargeList = rtnData.data.surChargeList
        this.schgReqRno = rtnData.data.schgReqRno

        for (const item of this.surChargeList) {
          if (item.frtCd === 'O/F' && item.cgoTypCd !== '01') {
            item.chk = '1'
          } else {
            item.chk = '0'
          }
          if (item.cntrTypCd === 'GP' || item.cntrTypCd === 'HC') {
            this.rateFreeDdsGPList = rtnData.data.rateFreeDdsList
          } else if (item.cntrTypCd === 'RF' || item.cntrTypCd === 'RH') {
            this.rateFreeDdsRFList = rtnData.data.rateFreeDdsList
          }
          if (item.cntrTypCd === 'GP' || item.cntrTypCd === 'HC') {
            if (item.cgoTypCd === '01') {
              if (this.vHZYn) {
                this.surChargeListDry.push(item)
              }
            } else {
              this.surChargeListDry.push(item)
            }
            dry = 'Y'
          } else if (item.cntrTypCd === 'RF' || item.cntrTypCd === 'RH') {
            if (item.cgoTypCd === '01') {
              if (this.vHZYn) {
                this.surChargeListRee.push(item)
              }
            } else {
              this.surChargeListRee.push(item)
            }
            reefee = 'Y'
          } else if (item.cntrTypCd === 'FR') {
            this.surChargeListFlat.push(item)
            flat = 'Y'
          } else if (item.cntrTypCd === 'TK') {
            this.surChargeListTank.push(item)
            tank = 'Y'
          } else if (item.cntrTypCd === 'OT') {
            this.surChargeListOT.push(item)
            ot = 'Y'
          } else {
            this.surChargeListEtc.push(item)
          }
          if (item.frtCd === 'DCF' || item.frtCd === 'SRD' || item.frtCd === 'AFS' || item.frtCd === 'AMS') {
            if (cntrType === 'GP' || cntrType === 'HC') {
              this.surChargeNoteGPList.push(item)
            } else if (cntrType === 'RF' || cntrType === 'RH') {
              this.surChargeNoteRFList.push(item)
            }
          }
        }

        if ((this.params.dlyCtrCd !== 'US' && this.params.porCtrCd !== 'US')) {
          if (dry === 'Y') {
            if (this.containerType.length === 0 || this.containerType.filter(vo => vo.cd === 'GP').length === 0) {
              this.containerType.push({ cdNm: 'Dry (GP or HC)', cd: 'GP', type: 'RA', frtAppNo: rtnData.data.frtAppNo })
            }
          }
          if (reefee === 'Y') {
            if (this.containerType.length === 0 || this.containerType.filter(vo => vo.cd === 'RF').length === 0) {
              this.containerType.push({ cdNm: 'REEFER (RF or RH)', cd: 'RF', type: 'RA', frtAppNo: rtnData.data.frtAppNo })
            }
          }
          if (flat === 'Y') {
            if (this.containerType.length === 0 || this.containerType.filter(vo => vo.cd === 'FR').length === 0) {
              this.containerType.push({ cdNm: 'Flat Rack', cd: 'FR', type: 'RA', frtAppNo: rtnData.data.frtAppNo })
            }
          }
          if (tank === 'Y') {
            if (this.containerType.length === 0 || this.containerType.filter(vo => vo.cd === 'TK').length === 0) {
              this.containerType.push({ cdNm: 'Tank', cd: 'TK', type: 'RA', frtAppNo: rtnData.data.frtAppNo })
            }
          }

          if (ot === 'Y') {
            if (this.containerType.length === 0 || this.containerType.filter(vo => vo.cd === 'OT').length === 0) {
              this.containerType.push({ cdNm: 'Open Top', cd: 'OT', type: 'RA', frtAppNo: rtnData.data.frtAppNo })
            }
          }
        }
        if (dry === 'Y') {
          this.searchMyOceanFreight()
        }

        this.checkExtension()

        var layerEcom = {
          event: 'ga4_purchase',
          ecommerce: {
            currency: '',
            value: '0',
            affiliation: this.auth.orgUserId + ' ' + this.auth.userName,
            transaction_id: this.params.frtAppNo,
            items: []
          }
        }

        window.dataLayer.push(layerEcom)
        this.setCalcuData()
      })
    },
    getFreSurcharge () {
      // 운임 Data
      let dry = 'N'
      let reefee = 'N'
      let cntrType = this.cntrTypCd2
      this.params.cntrTypCd = this.cntrTypCd2
      this.params.frtAppNo = ''
      this.params.frtResult = ''
      vslScheduleInfo.getPopFreSurcharge(this.params).then((rtnData) => {
        // console.log('######### [freSurcharge] getPopFreSurcharge #########')
        this.surChargeList = rtnData.data.surChargeList
        // this.of20Rate = rtnData.data.of20Rate
        // this.of40Rate = rtnData.data.of40Rate

        for (const item of this.surChargeList) {
          if (item.frtCd === 'O/F' && item.cgoTypCd !== '01') {
            item.chk = '1'
          } else {
            item.chk = '0'
          }
          if (item.cntrTypCd === 'GP' || item.cntrTypCd === 'HC') {
            this.rateFreeDdsGPList = rtnData.data.rateFreeDdsList
          } else if (item.cntrTypCd === 'RF' || item.cntrTypCd === 'RH') {
            this.rateFreeDdsRFList = rtnData.data.rateFreeDdsList
          }
          // KMTC ON 버튼용 세팅
          if (item.frtCd === 'O/F' && item.cntrTypCd === 'GP' && item.cgoTypCd !== '01') {
            this.apv20Ft = item.rate20
            this.apv40Ft = item.rate40
          }
          // 기존 세팅
          if (item.frtCd === 'DCF' || item.frtCd === 'SRD' || item.frtCd === 'AFS' || item.frtCd === 'AMS') {
            if (cntrType === 'GP' || cntrType === 'HC') {
              this.surChargeNoteGPList.push(item)
            } else if (cntrType === 'RF' || cntrType === 'RH') {
              this.surChargeNoteRFList.push(item)
            }
          }
          if (cntrType === 'GP') {
            if (item.cntrTypCd === 'GP' || item.cntrTypCd === 'HC') {
              if (item.cgoTypCd === '01') {
                if (this.vHZYn) {
                  this.surChargeListDry.push(item)
                }
              } else {
                this.surChargeListDry.push(item)
              }
            }
          } else if (cntrType === 'RF') {
           if (item.cntrTypCd === 'RF' || item.cntrTypCd === 'RH') {
              if (item.cgoTypCd === '01') {
                if (this.vHZYn) {
                  this.surChargeListRee.push(item)
                }
              } else {
                this.surChargeListRee.push(item)
              }
           }
          }
        }
        // 운임 유효기간
        if (cntrType === 'GP') {
          this.schgReqRnoGP = rtnData.data.schgReqRno
          this.startDtGP = rtnData.data.strDt.substring(0, 4) + '-' + rtnData.data.strDt.substring(4, 6) + '-' + rtnData.data.strDt.substring(6, 8)
          this.endDtGP = rtnData.data.endDt.substring(0, 4) + '-' + rtnData.data.endDt.substring(4, 6) + '-' + rtnData.data.endDt.substring(6, 8)
        } else if (cntrType === 'RF') {
          this.schgReqRnoRF = rtnData.data.schgReqRno
          this.startDtRF = rtnData.data.strDt.substring(0, 4) + '-' + rtnData.data.strDt.substring(4, 6) + '-' + rtnData.data.strDt.substring(6, 8)
          this.endDtRF = rtnData.data.endDt.substring(0, 4) + '-' + rtnData.data.endDt.substring(4, 6) + '-' + rtnData.data.endDt.substring(6, 8)
        }
        this.setCalcuData()
      })
    },
    // '확인'버튼 클릭시 검색조건 전체 validation check
    fnValidationAll () {
      const frm = document.querySelector('#frm')
      let isAllOk = true

      // 출발지 validation check
      if (!this.fnValidationPor(frm)) {
        isAllOk = false
      }
      // 도착지 validation check
      if (!this.fnValidationDly(frm)) {
        isAllOk = false
      }
      // 예상 출항일 validation check
      if (!this.fnValidationEtd(frm)) {
        isAllOk = false
      }

      return isAllOk
    },
    // 출발지 validation check
    fnValidationPor (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm')
      }

      const elem = frm.querySelectorAll('#polPol')
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isEmpty(this.params.porCtrCd) || this.$ekmtcCommon.isEmpty(this.params.porPlcCd)) {
        msg = this.$t('msg.FARE010T010_NEW.013') // 출발지를 입력해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    // 도착지 validation check
    fnValidationDly (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm')
      }

      const elem = frm.querySelectorAll('#podPod')
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isEmpty(this.params.dlyCtrCd) || this.$ekmtcCommon.isEmpty(this.params.dlyPlcCd)) {
        msg = this.$t('msg.FARE010T010_NEW.014') // 도착지를 입력해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    // 예상 출항일 validation check (오늘 날짜 + 60일을 초과할 수 없음.)
    fnValidationEtd (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm')
      }

      const elem = frm.querySelector('.datepicker')
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isEmpty(this.params.etd)) {
        msg = this.$t('msg.FARE010T010_NEW.015') // 예상 출항일을 선택해 주세요.
        isOk = false
      } else {
        const etd = this.$ekmtcCommon.getStrToDate(this.params.etd)
        const today = new Date()

        if (this.$ekmtcCommon.getDateToStrDelim(etd) < this.$ekmtcCommon.getDateToStrDelim(today)) {
          msg = this.$t('msg.FARE010T010_NEW.016') // 예상 출항일이 오늘 날짜보다 작을 수 없습니다.
          isOk = false
        } else if (today.setDate(today.getDate() + 60) < etd) {
           msg = this.$t('msg.FARE010T010_NEW.017') // 예상 출항일이 + 60일을 초과할 수 없습니다.
          isOk = false
        }
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    openPopup (compNm) {
      if (this.customComponent !== null) {
        this.customComponent = null
        this.$ekmtcCommon.layerClose('.inquiry_surcharge_pop')
      }

      this.customComponent = compNm
      this.$ekmtcCommon.layerOpen('.inquiry_surcharge_pop')
    },
    closePopup (obj) {
      if (obj && obj.negoYN) {
        this.customComponent = null
        this.$ekmtcCommon.layerClose('.inquiry_surcharge_pop')

        this.customComponent = 'request-quote-pop'
        this.$ekmtcCommon.layerOpen('.inquiry_surcharge_pop')
      } else {
        this.customComponent = null
        this.$ekmtcCommon.layerClose('.inquiry_surcharge_pop')
      }
    },
    getKmtcSpotTarget () {
      //menuCD 01은 로그를 남기지 않음. kmtc on 대상 여부만 조회
      schedule.getKmtcSpotTarget('01').then((response) => {
        this.kmtcSpotUserYn = response.data[0].kmtcSpotNegoYn
        this.kmtcSpotCoupon = response.data[0].kmtcSpotCoupon

        if (this.kmtcSpotCoupon !== 'Y') {
          this.detailYn = 'Y'
        }
      })
    },
    replaceCChargeList () {
      this.surChargeListDry = []
      this.surChargeListRee = []
      this.surChargeListFlat = []
      this.surChargeListTank = []
      this.surChargeListEtc = []
      this.surChargeNoteGPList = []
      this.surChargeNoteRFList = []
      this.surChargeListOT = []
      this.couponGPList = []
      this.couponRFList = []
      this.coupInfo.lgtRate = ''
      this.coupInfo.of20RateGP = ''
      this.coupInfo.of40RateGP = ''
      this.coupInfo.of20RateRF = ''
      this.coupInfo.of40RateRF = ''
      this.eyInfo.content1 = ''
      this.eyInfo.content2 = ''
      this.gpCpYn = '0'
      this.rfCpYn = '0'
      this.eyYn = 'N'
      this.params.lcDcYn = '0'
      this.startDtGP = ''
      this.endDtGP = ''
      this.startDtRF = ''
      this.endDtRF = ''
      this.frtAppNoGP = ''
      this.frtAppNoRF = ''
      this.reqRnoGP = ''
      this.reqRnoRF = ''
      this.schgReqRnoGP = ''
      this.schgReqRnoRF = ''
      this.params.frtResult = ''

      this.frtPncCd = ''
      this.dcYn = ''
      this.saveShprNm = ''
      this.lssYn = ''
      this.sales20Rate = ''
      this.sales40Rate = ''
      this.params.lcDcYn = '0'
      this.params.kmtcOnShprNm = ''
      this.params.kmtcOn20 = ''
      this.params.kmtcOn40 = ''

      this.kmtcOnNowNoticeMsg = ''
      this.kmtcOnNowNoticeSubMsg = ''
      this.kmtcOnNowDisabledYn = 'N'

      $('#kmtcOnApply').removeClass('disabled')
    },
    calcPromotionDC (cntrType, originAmt, frtCd, cntrTypCd, cgoTypNm) {
      let calcAmt = 0
      let calcDcRate = 0

      // originAmt 숫자가 아닌 경우
      if (originAmt <= 0 || originAmt === 'NaN') {
        return this.$ekmtcCommon.changeNumberFormat(originAmt, { isComma: true })
      }

      if (frtCd === 'O/F' && cntrTypCd === 'GP') {
        // GP and Cargo HZ 가 아니면서 직접할인 이면, 차액계산 저장하여 Cargo HZ 할인시 사용함
        if (cgoTypNm === undefined && cntrType === '20') {
          this.spread20 = originAmt - this.params.dtDcRate01
        } else if (cgoTypNm === undefined && cntrType === '40') {
          this.spread40 = originAmt - this.params.dtDcRate02
        }

        // 프로모션의 offset과 직접운임간 우선순위가 결정되지 않아 우선 offset에 우선순위를 두고 계산함.
        // 금액 계산시 %, 정액 할인은 원단위 올림
        // offset 금액 계산 1
        if (cntrType === this.params.ofCntrSize01) {
          if (this.params.ofDcType01 === '$') {
            calcAmt = originAmt - this.params.ofDcRate01
          } else { // % 계산
            calcDcRate = this.params.ofDcRate01 / 100
            calcAmt = originAmt - Math.floor(calcDcRate * originAmt)
          }
          if (calcAmt <= 0) {
            calcAmt = 1
          }
          return this.$ekmtcCommon.changeNumberFormat(calcAmt, { isComma: true })
        }

        // offset 금액 계산 2
        if (cntrType === this.params.ofCntrSize02) {
          if (this.params.ofDcType02 === '$') {
            calcAmt = originAmt - this.params.ofDcRate02
          } else { // % 계산
            calcDcRate = this.params.ofDcRate02 / 100
            calcAmt = originAmt - Math.floor(calcDcRate * originAmt)
          }
          if (calcAmt <= 0) {
            calcAmt = 1
          }
          return this.$ekmtcCommon.changeNumberFormat(calcAmt, { isComma: true })
        }

        // 직접운임 금액 계산 1
        if (cntrType === this.params.dtCntrSize01) {
          if (this.params.dtDcType01 === '$') {
            if (cgoTypNm === 'HZ') {
              calcAmt = originAmt - this.spread20
            } else {
              calcAmt = this.params.dtDcRate01
            }
          } else { // % 계산
            calcDcRate = this.params.dtDcRate01 / 100
            calcAmt = originAmt - Math.floor(calcDcRate * originAmt)
          }
          if (calcAmt <= 0) {
            calcAmt = 1
          }
          return this.$ekmtcCommon.changeNumberFormat(calcAmt, { isComma: true })
        }

        // 직접운임 금액 계산 2
        if (cntrType === this.params.dtCntrSize02) {
          if (this.params.dtDcType02 === '$') {
            if (cgoTypNm === 'HZ') {
              calcAmt = originAmt - this.spread40
            } else {
              calcAmt = this.params.dtDcRate02
            }
          } else { // % 계산
            calcDcRate = this.params.dtDcRate02 / 100
            calcAmt = originAmt - Math.floor(calcDcRate * originAmt)
          }
          if (calcAmt <= 0) {
            calcAmt = 1
          }
          return this.$ekmtcCommon.changeNumberFormat(calcAmt, { isComma: true })
        }
      }
      return this.$ekmtcCommon.changeNumberFormat(originAmt, { isComma: true })
    },
    checkExtension () {
      this.expDate = app.$ekmtcCommon.getStrToDate(this.endDt)
      let today = new Date()
      let twoWeekAfter = new Date()
      twoWeekAfter = new Date(twoWeekAfter.setDate(twoWeekAfter.getDate() + 14))
      // 오프라인 화주의 경우
      // 1. 운임 유효기한 만료 임박(2주전~금일) >> 오늘 > 만료일 > 2주후
      // 2. 유효기한 만료된 건은 ‘연장요청’ 버튼 노출 >> 만료건의 경우 검색불가
      // frtEstnYn = undefined
      if ((today <= this.expDate && this.expDate <= twoWeekAfter) && this.frtEstnYn !== 'I' && this.frtExtsStsCd === '00' && this.cstBidgMgrNo === undefined) {
        this.showExtensionBtn = 'Y'
      } else if (today > this.expDate && this.frtEstnYn !== 'I' && this.frtExtsStsCd === '00' && this.$ekmtcCommon.isEmpty(this.cstBidgMgrNo)) {
        this.showExtensionBtn = 'Y'
      }

      if (today < this.expDate) {
        this.showNegoBtn = 'Y'
      }
    },
    showDetail () {
      if (this.detailYn === 'Y') {
        this.detailYn = 'N'
      } else {
        this.detailYn = 'Y'
      }
    },
    showCpDetail () {
      if (this.cpDetailYn === 'Y') {
        this.cpDetailYn = 'N'
      } else {
        this.cpDetailYn = 'Y'
      }
    },
    dateFormat (dt) {
      let year = dt.substring(0, 4)
      let month = dt.substring(4, 6)
      let date = dt.substring(6, 8)

      return year + '-' + month + '-' + date
    },
    screenPrint () {
      const ele = document.querySelector('.print_screen')
      this.$ekmtcCommon.elemAddClass(ele, 'screen_shot')

      const options = {
        cssSelector: '.print_screen',
        page: 'FreeSurcharge'
      }

      this.$ekmtcCommon.screenToPrint(options).then(res => {
        if (res === undefined || res === null) {
          this.$ekmtcCommon.alertDefault(this.$t('msg.CSBK100.244'))
        }
        this.$ekmtcCommon.elemRemoveClass(ele, 'screen_shot')
      }).catch(() => {
        this.$ekmtcCommon.elemRemoveClass(ele, 'screen_shot')
      })
    },
    customEvent (e) {
      const type = e.type

      switch (type) {
        case 'click': {
          if (e.target.id === 'favor') {
            this.showHisto = false
          } else if (e.target.id === 'histo') {
            this.showFavor = false
          } else {
            if (e.target.id === 'searchRadio' || e.target.type === 'radio') {
              break
            } else {
              this.showHisto = false
              this.showFavor = false
            }
          }
        }
      }
    },
    async searchCouponList () {
      const coupParams = {
        porCtrCd: this.params.porCtrCd,
        porPlcCd: this.params.porPlcCd,
        dlyCtrCd: this.params.dlyCtrCd,
        dlyPlcCd: this.params.dlyPlcCd,
        kind: 'R',
        fromDt: this.params.etd,
        toDt: this.params.etd,
        cntrTyp: 'GP',
        couponTyp: ''
      }

      await schedule.getMyCouponList(coupParams).then(response => {
        this.couponGPList = response.data
        this.eyYn = 'N'

        let spliceIdx = []
        for (const item of this.couponGPList) {
          let startDt = item.strDt.substring(0, 4) + '.' + item.strDt.substring(4, 6) + '.' + item.strDt.substring(6, 8)
          let endDt = item.endDt.substring(0, 4) + '.' + item.endDt.substring(4, 6) + '.' + item.endDt.substring(6, 8)

          if (item.couponTyp === '04') {
            spliceIdx.push(this.couponGPList.indexOf(item))
            this.eyYn = 'Y'
            this.eyInfo.content1 = '출항일  → ' + item.eryBkgDds + '일 전 부킹 : 선복보장혜택'
            this.eyInfo.content2 = startDt + ' - ' + endDt + ' (ETD 기준)' + '\b\b ' + item.porCtrPlc + ' → ' + item.dlyCtrPlc + '\b\b ' + item.cntrTypCd
            if (item.rteCd !== undefined) {
              this.eyInfo.content2 = this.eyInfo.content2 + '\b\b ' + item.rteCd
            }
            if (item.vslCd !== undefined) {
              this.eyInfo.content2 = this.eyInfo.content2 + '\b\b ' + item.vslCd
            }
            if (item.voyNo !== undefined) {
              this.eyInfo.content2 = this.eyInfo.content2 + '\b\b ' + item.voyNo
            }
          } else {
            if (item.couponTyp === '05') {
              item.title = '※ 조건이 충족될 경우 자동반영 됩니다.'
              item.content1 = '[ 경량할인 ] '
              item.content4 = item.rmk
              item.content2 = '중량 조건 : ≤' + item.lgtCgoWt20 + "Kg(20' GP Only)"
              item.content3 = '적용 구간 : ' + item.porCtrPlc + ' → ' + item.dlyCtrPlc
              if (item.rteCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.rteCd
              }
              if (item.vslCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.vslCd
              }
              if (item.voyNo !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.voyNo
              }
              item.content3 = item.content3 + '\b|\b ' + startDt + ' - ' + endDt + ' (ETD 기준)'
            } else if (item.couponTyp === '01') {
              item.content1 = '[ 일반할인 ] '
              item.content4 = item.rmk
              item.content2 = '컨테이너 타입 : ' + item.cntrTypCd
              item.content3 = '적용 구간 : ' + item.porCtrPlc + ' → ' + item.dlyCtrPlc
              if (item.rteCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.rteCd
              }
              if (item.vslCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.vslCd
              }
              if (item.voyNo !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.voyNo
              }
              item.content3 = item.content3 + '\b|\b ' + startDt + ' - ' + endDt + ' (ETD 기준)'
            } else if (item.couponTyp === '02') {
              item.content1 = '[ 누적할인 ] '
              item.content4 = item.rmk
              item.content2 = '컨테이너 타입 : ' + item.cntrTypCd
              item.content3 = '적용 구간 : ' + item.porCtrPlc + ' → ' + item.dlyCtrPlc
              if (item.rteCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.rteCd
              }
              if (item.vslCd !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.vslCd
              }
              if (item.voyNo !== undefined) {
                item.content3 = item.content3 + '\b|\b ' + item.voyNo
              }
              item.content3 = item.content3 + '\b|\b ' + startDt + ' - ' + endDt + ' (ETD 기준)'
            }
          }
        }
        this.couponGPList.splice(spliceIdx[0], spliceIdx.length)

        if (this.couponGPList.length > 0) {
          this.params.cpDcReqRno = this.couponGPList[0].couponNo
          this.coupInfo.couponNoGP = this.couponGPList[0].couponNo
          this.coupInfo.couponNmGP = this.couponGPList[0].couponNm
          this.coupInfo.strDtGP = this.couponGPList[0].strDt
          this.coupInfo.endDtGP = this.couponGPList[0].endDt
          this.coupInfo.of20RateGP = this.couponGPList[0].of20Rate
          this.coupInfo.of40RateGP = this.couponGPList[0].of40Rate
        }
      }).catch(err => {
        console.log(err)
      })

      // coupParams.cntrTyp = 'RF'
      // await schedule.getMyCouponList(coupParams).then(response => {
      //   this.couponRFList = response.data

      //   if (this.couponRFList.length > 0) {
      //     this.coupInfo.couponNoRF = this.couponGPList[0].couponNo
      //     this.coupInfo.couponNmRF = this.couponGPList[0].couponNm
      //     this.coupInfo.strDtRF = this.couponGPList[0].strDt
      //     this.coupInfo.endDtRF = this.couponGPList[0].endDt
      //     this.coupInfo.of20RateRF = this.couponGPList[0].of20Rate
      //     this.coupInfo.of40RateRF = this.couponGPList[0].of40Rate
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    async acceptQuote () {
        let rate20GP = 0
        let rate40GP = 0
        let rate20RF = 0
        let rate40RF = 0

        for (const item of this.surChargeListDry) {
          if (item.chk === '1' && item.cntrTypCd === 'GP') {
            rate20GP = item.rate20
            rate40GP = item.rate40
          }
        }
        for (const item of this.surChargeListRee) {
          if (item.chk === '1' && item.cntrTypCd === 'RF') {
            rate20RF = item.rate20
            rate40RF = item.rate40
          }
        }

      const params = {
        porCtrCd: this.params.porCtrCd,
        porPlcCd: this.params.porPlcCd,
        dlyCtrCd: this.params.dlyCtrCd,
        dlyPlcCd: this.params.dlyPlcCd,
        etd: this.params.etd,
        strDt: this.tapStatus === 1 ? this.startDtGP.replace(/-/gi, '') : this.startDtRF.replace(/-/gi, ''),
        endDt: this.tapStatus === 1 ? this.endDtGP.replace(/-/gi, '') : this.endDtRF.replace(/-/gi, ''),
        reqRno: this.tapStatus === 1 ? this.params.reqRnoGP : this.params.reqRnoRF,
        schgReqRno: this.tapStatus === 1 ? this.schgReqRnoGP : this.schgReqRnoRF,
        // of20Rate: this.tapStatus === 1 ? rate20GP : rate20RF,
        // of40Rate: this.tapStatus === 1 ? rate40GP : rate40RF,
        cntrTypeCd: this.tapStatus === 1 ? 'GP' : 'RF',
        eiCatCd: this.params.eiCatCd,
        promotionChk: '',
        scenarioCd: '',
        promoNo: '',
        vslReqRno: this.tapStatus === 1 ? this.schgReqRnoGP : this.schgReqRnoRF,
        vslSeq: '',
        spread20: '',
        spread40: '',
        hotDealYn: this.tapStatus === 1 ? 'Y' : 'N',
        lssPc: ''
      }
      if (params.reqRno !== '') {
        await vslScheduleInfo.insertAcceptQuote(params).then((rtnData) => {
          this.surChargeList = rtnData.data.surChargeList
          this.frtAppNo = rtnData.data.frtAppNo
          this.checkCharge = 'Y'
          this.params.frtResult = rtnData.data.frtResult
          if (this.tapStatus === 1) {
            this.frtAppNoGP = rtnData.data.frtAppNo
            this.params.reqRnoGP = ''
          } else if (this.tapStatus === 2) {
            this.frtAppNoRF = rtnData.data.frtAppNo
            this.params.reqRnoRF = ''
          }

          this.setCalcuData()
        })
      } else {
        this.params.frtResult = 'Y'
      }
    },
    setCalcuData (couponNo) {
      if (this.tapStatus === 1) {
        this.coupInfo.lcDcRate20 = 0
        this.coupInfo.lcDcRate40 = 0
        this.coupInfo.of20RateGP = 0
        this.coupInfo.of40RateGP = 0
        for (const item of this.couponGPList) {
          if (item.chk === '1') {
            if (item.couponTyp === '05') {
              this.coupInfo.lcDcRate20 = Number(this.coupInfo.lcDcRate20) + Number(item.of20Rate)
              this.coupInfo.lcDcRate40 = Number(this.coupInfo.lcDcRate40) + Number(item.of40Rate)
            } else {
              if (couponNo !== '' && item.couponNo !== couponNo) {
                item.chk = 0
              } else {
                this.coupInfo.of20RateGP = Number(this.coupInfo.of20RateGP) + Number(item.of20Rate)
                this.coupInfo.of40RateGP = Number(this.coupInfo.of40RateGP) + Number(item.of40Rate)
              }
            }
          }
        }

        for (const item of this.surChargeListDry) {
          if (item.chk === '1' && item.cntrTypCd === 'GP') {
            this.calcuAmt.from20 = Number(item.rate20)
            this.calcuAmt.from40 = Number(item.rate40)
            this.calcuAmt.kmtcFrom20 = Number(item.rate20)
            this.calcuAmt.kmtcFrom40 = Number(item.rate40)
          }
          if (item.frtCd === 'O/F' && item.cgoTypNm === 'HZ' && item.cntrTypCd === 'GP') {
            this.calcuAmt.hzFrom20 = Number(item.rate20)
            this.calcuAmt.hzFrom40 = Number(item.rate40)
          }
        }
        this.calcuAmt.coup20 = Number(this.coupInfo.of20RateGP)
        this.calcuAmt.coup40 = Number(this.coupInfo.of40RateGP)
        // this.calcuAmt.earlyB = this.params.eyDcYn === '1' ? 5 : 0
        this.calcuAmt.lightC = Number(this.coupInfo.lcDcRate20)
        this.calcuAmt.lightC40 = Number(this.coupInfo.lcDcRate40)
        if (isNaN(this.sales20Rate)) {
          this.sales20Rate = 0
        }
        if (isNaN(this.sales40Rate)) {
          this.sales40Rate = 0
        }
        this.calcuAmt.kmtcOn20 = Number(this.sales20Rate)
        this.calcuAmt.kmtcOn40 = Number(this.sales40Rate)
        this.calcuAmt.from20 = Number(this.calcuAmt.from20) + Number(this.sales20Rate)
        this.calcuAmt.from40 = Number(this.calcuAmt.from40) + Number(this.sales40Rate)
      } else {
        this.calcuAmt.kmtcOn20 = 0
        this.calcuAmt.kmtcOn40 = 0
        for (const item of this.surChargeListRee) {
          if (item.chk === '1' && item.cntrTypCd === 'RF') {
            this.calcuAmt.from20 = Number(item.rate20)
            this.calcuAmt.from40 = Number(item.rate40)
            this.calcuAmt.kmtcFrom20 = Number(item.rate20)
            this.calcuAmt.kmtcFrom40 = Number(item.rate40)
          }
          if (item.frtCd === 'O/F' && item.cgoTypNm === 'HZ' && item.cntrTypCd === 'RF') {
            this.calcuAmt.hzFrom20 = Number(item.rate20)
            this.calcuAmt.hzFrom40 = Number(item.rate40)
          }
        }
        this.calcuAmt.coup20 = Number(this.coupInfo.of20RateRF)
        this.calcuAmt.coup40 = Number(this.coupInfo.of40RateRF)
        this.calcuAmt.earlyB = 0
        this.calcuAmt.lightC = 0
        this.calcuAmt.lightC40 = 0
      }
      this.calcuAmt.to20 = Number(this.calcuAmt.from20) - (Number(this.calcuAmt.kmtcOn20) + Number(this.calcuAmt.coup20) + Number(this.calcuAmt.earlyB) + Number(this.calcuAmt.lightC))
      this.calcuAmt.to40 = Number(this.calcuAmt.from40) - (Number(this.calcuAmt.kmtcOn40) + Number(this.calcuAmt.coup40) + Number(this.calcuAmt.earlyB) + Number(this.calcuAmt.lightC40))
      this.calcuAmt.hzTo20 = Number(this.calcuAmt.hzFrom20) - (Number(this.calcuAmt.kmtcOn20) + Number(this.calcuAmt.coup20) + Number(this.calcuAmt.earlyB) + Number(this.calcuAmt.lightC))
      this.calcuAmt.hzTo40 = Number(this.calcuAmt.hzFrom40) - (Number(this.calcuAmt.kmtcOn40) + Number(this.calcuAmt.coup40) + Number(this.calcuAmt.earlyB) + Number(this.calcuAmt.lightC40))
      this.calcuAmt.to20 = this.calcuAmt.to20 < 0 ? 0 : this.calcuAmt.to20
      this.calcuAmt.to40 = this.calcuAmt.to40 < 0 ? 0 : this.calcuAmt.to40
      this.calcuAmt.hzTo20 = this.calcuAmt.hzTo20 < 0 ? 0 : this.calcuAmt.hzTo20
      this.calcuAmt.hzTo40 = this.calcuAmt.hzTo40 < 0 ? 0 : this.calcuAmt.hzTo40

      if ((this.tapStatus === 1 ? this.frtAppNoGP : this.frtAppNoRF) === '') {
        $('#bkgBtn').addClass('disabled')
        $('#raBtn').removeClass('disabled')
      } else {
        $('#bkgBtn').removeClass('disabled')
        $('#raBtn').addClass('disabled')
      }
    },
    // KMTC ON NEGO 제출
    async kmtcOnNegoRequest () {
        if (this.params.kmtcOnShprNm.length < 1) {
          await this.$ekmtcCommon.asyncAlertMessage({
            message: '실화주를 입력하세요.',
            onCloseSelf: (resolve, $Simplert) => {
              resolve(false)
              $Simplert.close()

              document.getElementById('kmtcOnShprNm').focus()
            }
          })
          return
        }

        if (this.params.kmtcOn20 < 1 || this.params.kmtcOn20 === '') {
          await this.$ekmtcCommon.asyncAlertMessage({
            message: '운임을 입력하세요.',
            onCloseSelf: (resolve, $Simplert) => {
              resolve(false)
              $Simplert.close()

              document.getElementById('kmtcOn20').focus()
            }
          })
          return
        }

        if (this.params.kmtcOn40 < 1 || this.params.kmtcOn40 === '') {
          await this.$ekmtcCommon.asyncAlertMessage({
            message: '운임을 입력하세요.',
            onCloseSelf: (resolve, $Simplert) => {
              resolve(false)
              $Simplert.close()

              document.getElementById('kmtcOn40').focus()
            }
          })
          return
        }

        // if (this.negoAfterText !== '') {
        //   this.$ekmtcCommon.asyncAlertMessage({ message: '네고 완료된 운임입니다.' })
        //   return
        // }

        let dlyCtrLssYn = ''
        let acceptYn = ''
        // 중국, 홍콩, 대만은 LSS 미포함
        if (this.dlyCtrCd === 'CN' || this.dlyCtrCd === 'HK' || this.dlyCtrCd === 'TW') {
          dlyCtrLssYn = 'N'
        } else {
          dlyCtrLssYn = 'Y'
        }

        // if (this.frtAppNoGP === '') {
        //   const checkParams = {
        //     reqRno: this.params.reqRnoGP
        //   }
        //   await schedule.getNegoCheck(checkParams).then((response) => {
        //     if (response.data !== '') {
        //       acceptYn = response.data.negoChkYn
        //     } else {
        //       errChk = true
        //     }
        //  })
        // }
        // if (acceptYn === 'Y') {
        //   await this.acceptQuote()
        // }

        await this.acceptQuote()

        const negoParams = {
          frtAppNo: this.frtAppNoGP,
          actShpNm: this.params.kmtcOnShprNm,
          req20Ft: this.params.kmtcOn20,
          req40Ft: this.params.kmtcOn40,
          apv20Ft: this.calcuAmt.from20,
          apv40Ft: this.calcuAmt.from40,
          lssYn: 'N',
          dlyCtrLssYn: dlyCtrLssYn,
          frtPncCd: this.frtPncCd,
          negoStepChk: '1step',
          porCtrCd: this.params.porCtrCd,
          porPlcCd: this.params.porPlcCd,
          dlyCtrCd: this.params.dlyCtrCd,
          dlyPlcCd: this.params.dlyPlcCd,
          fromDt: this.startDtGP
        }
        let errChk = false
        let msg = null

        await schedule.kmtcOnNegoRequest(negoParams).then((response) => {
          if (response.data !== '') {
            if (response.data.negoYN === 'L' || response.data.negoYN === 'M') {
              msg = response.data.negoYN
              this.$ekmtcCommon.asyncAlertMessage({ message: response.data.lssPc })
              return
            }

            this.params.frtAppNo = response.data.frtAppNo

            if (response.data.negoYN === 'R' || response.data.negoYN === 'K') {
              msg = response.data.lssPc
            } else if (response.data.negoYN === 'X') {
              msg = response.data.lssPc
              this.negoAfterText = '해당 SC No. 운임이 가장 저렴한 운임입니다.'
              this.$ekmtcCommon.asyncAlertMessage({ message: msg })
              msg = response.data.negoYN // X인 경우 세팅
            }
          } else {
            errChk = true
          }
        })

        // X는 현재 RA가 최저 운임, L은 요청운임 기준 미달, M은 1st min. 설정 누락
        if (msg === 'X' || msg === 'L' || msg === 'M') return

        if (!errChk) {
          // 화주에게 운임 할인 진행할지 확인 메세지 출력
          if (!await this.$ekmtcCommon.asyncAlertMessage({ message: msg, useConfirmBtn: true })) {
            return
          }

          // 2step은 운임할인 로직 실행하여 신규 운임 생성하는 단계
          negoParams.negoStepChk = '2step'

          // 2step 세팅하여 운임할인 로직 호출
          await schedule.kmtcOnNegoRequest(negoParams).then((response) => {
            if (response.data !== '') {
              if (response.data.negoYN === 'L' || response.data.negoYN === 'M') {
                this.$ekmtcCommon.asyncAlertMessage({ message: response.data.lssPc })
                return
              }
              this.frtAppNoGP = response.data.frtAppNo

              if (response.data.negoYN === 'R' || response.data.negoYN === 'K') {
                msg = '운임 조정이 완료되었습니다. 부킹 후 S/R 제출 시 조정된 운임이 자동으로 반영됩니다.'
                this.negoAfterText = '네고완료! 리스트의 SC번호 클릭하여 확인하세요.'
              }

              this.params.kind = 'N' // 일반 검색과 구분하기 위해 네고 완료 구분자를 세팅하고, 아래 검색시 체크함
              this.$ekmtcCommon.asyncAlertMessage({ message: msg }).then(() => {
                this.params.kind = 'R' // 일반 검색 구분자(요청일자)
                this.$emit('close')
              })
              this.fnSearchSurCharge()
            }
          })
        } else { // 화주 등급 또는 최저 운임 설정이 없이 진행이 불가능한 경우 디지털세일즈팀에게 메일 발송함
          if (await this.$ekmtcCommon.asyncAlertMessage({ message: '해당 구간의 운임은 아직 조정이 어렵습니다. 담당 직원에게 문의하시겠습니까?', useConfirmBtn: true })) {
            // 운임 할인에 필요한 화주 등급 데이터가 없거나, 최저 운임 데이터가 없는 경우 위 메세지가 노출되고, 이후 kmtcon@ekmtc.com 계정으로 메일을 발송함
            msg = '화주 코드 : ' + this.auth.cstCd + '<br>' +
                  '화주 명 : ' + this.memberDetail.compEname + '<br>' +
                  '구간 : ' + negoParams.porPlcCd + ' - ' + negoParams.dlyPlcCd + '<br>' +
                  '기간 : ' + negoParams.fromDt + '<br>' +
                  '담당자 이름 : ' + this.auth.userName + '<br>' +
                  '담당자 이메일 : ' + this.selectedProfile.emlAddr + '<br>' +
                  '담당자 전화번호 : ' + this.memberDetail.cel1 + '-' + this.memberDetail.cel2 + '-' + this.memberDetail.cel3

            const formData = new FormData()
            formData.append('toEmail', 'kmtcon@ekmtc.com')
            formData.append('fromEmail', 'eKMTC@kmtcOnNow.menu')
            formData.append('subject', 'KMTC ON NOW 운임 문의')
            formData.append('message', msg)

            await commons.sendEmail(formData).then((response) => {
              this.$ekmtcCommon.asyncAlertMessage({ message: '담당 직원에게 해당 구간 문의 메일이 발송되었습니다.' })
            })
          }
        }
    },
    async searchMyOceanFreight () {
      const formData = {
        kind: 'N', //'D'
        frtAppNo: this.frtAppNoGP
      }
      this.myOceanFreightList = []

      await schedule.myOceanFreightPremium(formData).then((response) => {
        this.apv20FtList = []
        this.apv40FtList = []

          if (response.status === 200) {
            const respOceanFreightList = response.data.myOceanFreightList

            if (respOceanFreightList.length > 0) {
              let imsiFrtAppNo = null
              let imsiFrtJson = {}
              let gp20 = ''
              let gp40 = ''

              // 연속 데이터 가공 loop
              respOceanFreightList.forEach((respOceanFreight, index) => {
                if (imsiFrtAppNo === respOceanFreight.frtAppNo) {
                  // 이전 FrtAppNo와 현재 FrtAppNo가 같을 때는 cntrTypCd 값과 cgoTypNm 값만
                  // 배열에 저장한다. (나중에 중복 제거하고 ','로 join할 예정)
                  if (this.$ekmtcCommon.isNotEmpty(respOceanFreight.cntrTypCd)) {
                    imsiFrtJson.cntrTypCd.push(respOceanFreight.cntrTypCd)
                  }
                  if (this.$ekmtcCommon.isNotEmpty(respOceanFreight.cgoTypNm)) {
                    imsiFrtJson.cgoTypNm.push(respOceanFreight.cgoTypNm)
                  }
                  if (respOceanFreight.cntrSzCd === '20' && respOceanFreight.cntrTypCd === 'GP' && respOceanFreight.cgoTypCd !== '01') {
                    gp20 = respOceanFreight.rate
                  }
                  // 40은 GP와 HC를 동일하게 오퍼하고, 고려해운에 40GP 컨테이너가 없어 40HC 기준으로 체크하도록 함.
                  if (respOceanFreight.cntrSzCd === '40' && respOceanFreight.cntrTypCd === 'HC' && respOceanFreight.cgoTypCd !== '01') {
                    gp40 = respOceanFreight.rate
                  }
                } else {
                  // 이전 FrtAppNo와 현재 FrtAppNo가 같지 않을 때는
                  // 실제 그리드에서 쓸 데이터 변수에 임시 변수 값을 넣어준다.
                  if (this.$ekmtcCommon.isNotEmpty(imsiFrtAppNo)) {
                    this.myOceanFreightList.push(imsiFrtJson)
                  }

                  imsiFrtAppNo = respOceanFreight.frtAppNo
                  imsiFrtJson = JSON.parse(JSON.stringify(respOceanFreight))

                  imsiFrtJson.cntrTypCd = []
                  if (this.$ekmtcCommon.isNotEmpty(respOceanFreight.cntrTypCd)) {
                    imsiFrtJson.cntrTypCd.push(respOceanFreight.cntrTypCd)
                  }
                  imsiFrtJson.cgoTypNm = []
                  if (this.$ekmtcCommon.isNotEmpty(respOceanFreight.cgoTypNm)) {
                    imsiFrtJson.cgoTypNm.push(respOceanFreight.cgoTypNm)
                  }
                  imsiFrtJson.oceFrt = []
                  if (respOceanFreight.cntrSzCd === '20' && respOceanFreight.cntrTypCd === 'GP' && respOceanFreight.cgoTypCd !== '01') {
                    gp20 = respOceanFreight.rate
                  }
                  // 40은 GP와 HC를 동일하게 오퍼하고, 고려해운에 40GP 컨테이너가 없어 40HC 기준으로 체크하도록 함.
                  if (respOceanFreight.cntrSzCd === '40' && respOceanFreight.cntrTypCd === 'HC' && respOceanFreight.cgoTypCd !== '01') {
                    gp40 = respOceanFreight.rate
                  }
                }

                // oceFrt 항목 추가
                if (gp20 !== '' && gp40 !== '' && this.$ekmtcCommon.isEmpty(imsiFrtJson.oceFrt)) {
                  imsiFrtJson.oceFrt.push(gp20 + '/' + gp40)
                  this.apv20FtList.push(gp20)
                  this.apv40FtList.push(gp40)
                  gp20 = ''
                  gp40 = ''
                }

                if (index === (respOceanFreightList.length - 1)) {
                  this.myOceanFreightList.push(imsiFrtJson)
                }
              })

              // 컨테이너 타입, 카고 타입 중복 데이터 삭제
              this.myOceanFreightList.forEach(myOceanFreight => {
                myOceanFreight.cntrTypCd = myOceanFreight.cntrTypCd.length > 0 ? [...new Set(myOceanFreight.cntrTypCd)].sort().join(',') : ''
                myOceanFreight.cgoTypNm = myOceanFreight.cgoTypNm.length > 0 ? [...new Set(myOceanFreight.cgoTypNm)].sort().join(',') : ''
              })
            }
          }
          this.frtPncCd = this.myOceanFreightList[0].frtPncCd
          this.dcYn = this.myOceanFreightList[0].dcYn
          this.saveShprNm = this.myOceanFreightList[0].saveShprNm
          this.sales20Rate = this.myOceanFreightList[0].sales20Rate
          this.sales40Rate = this.myOceanFreightList[0].sales40Rate
          if (this.dcYn === 'Y') {
            $('#kmtcOnApply').addClass('disabled')
          } else {
            $('#kmtcOnApply').removeClass('disabled')
          }
          this.setCalcuData()
      })
    },
    async saveFreightQuotation () {
      if ((this.tapStatus === 1 ? this.frtAppNoGP : this.frtAppNoRF) === '') {
        await this.acceptQuote()
      }
    },
    goBooking () { // freightRnP - KMTC ON 운임선택시 일반, 프리미엄 운임 선택 확인
      this.$router.push({ name: 'booking-new', params: null }).catch(() => {})
    },
    setKmtcOnNowNotice () {
      const polCtrCd = this.params.porCtrCd
      const dlyCtrCd = this.params.dlyCtrCd

      this.kmtcOnNowNoticeMsg = ''
      this.kmtcOnNowNoticeSubMsg = ''
      this.kmtcOnNowDisabledYn = 'N'

      // REEFER 컨테이너
      if (this.tapStatus === 2) {
        this.kmtcOnNowNoticeMsg = ''
        this.kmtcOnNowNoticeSubMsg = this.$t('msg.FARE010T010_NEW.058')
        this.kmtcOnNowDisabledYn = 'Y'
        return
      }

      // 일본향/발 구간
      if (polCtrCd === 'JP' || dlyCtrCd === 'JP') {
        this.kmtcOnNowNoticeMsg = ''
        this.kmtcOnNowNoticeSubMsg = this.$t('msg.FARE010T010_NEW.062')
        this.kmtcOnNowDisabledYn = 'Y'
        return
      }

      // 수입 구간: 해외 출발 + 한국 도착
      if (polCtrCd !== 'JP' && polCtrCd !== 'KR' && dlyCtrCd === 'KR') {
        this.kmtcOnNowNoticeMsg = this.$t('msg.FARE010T010_NEW.061')
        this.kmtcOnNowNoticeSubMsg = this.$t('msg.FARE010T010_NEW.063')
        this.kmtcOnNowDisabledYn = 'Y'
      }
    }
  }
}
</script>
<style>
.content_box {
  padding:10px;
  border-color:#C7DAFF;
}
.content_box .tab li.on {
  height:31px;
  border-bottom:0;
  border-top:1px solid #C7DAFF;
}
.content_box .tab li.on a {
  background-color:#F0F5FF;
}
.float_calcu_box {
  position: fixed;
  top:120px;
  width: 303px;
}
.footer .hidden{
  visibility: hidden;
}
</style>
